var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/offers/offers.tsx
import React85, { useMemo as useMemo3 } from "react";
import { EGDSCard as EGDSCard5, EGDSCardPlaceholder as EGDSCardPlaceholder2 } from "@egds/react-core/cards";
import { EGDSPageLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { gql as gql93, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";

// src/components/utils/date.ts
var BASE_RADIX = 10;
var NO_RESULT_PATTERN = "-";
var convertDateInputToFragment = date => ({
  __typename: "Date",
  day: date.day,
  month: date.month,
  year: date.year
});
var convertDateFragmentToInput = date => ({
  day: date.day,
  month: date.month,
  year: date.year
});
var convertDateStringToInput = date => {
  const dateSplit = date.split("-");
  return {
    year: parseInt(dateSplit[0], BASE_RADIX),
    month: parseInt(dateSplit[1], BASE_RADIX),
    day: parseInt(dateSplit[2], BASE_RADIX)
  };
};
var convertDateRangeStringToInput = (startDate, endDate) => {
  const startDateList = startDate.split("-");
  const endDateList = endDate.split("-");
  return {
    startDate: {
      year: parseInt(startDateList[0], BASE_RADIX),
      month: parseInt(startDateList[1], BASE_RADIX),
      day: parseInt(startDateList[2], BASE_RADIX)
    },
    endDate: {
      year: parseInt(endDateList[0], BASE_RADIX),
      month: parseInt(endDateList[1], BASE_RADIX),
      day: parseInt(endDateList[2], BASE_RADIX)
    }
  };
};
var findFirstAvailableDate = results => {
  var _a;
  const dateResult = (_a = results.find(result => result.label !== NO_RESULT_PATTERN)) == null ? void 0 : _a.date;
  return dateResult ? convertDateFragmentToInput(dateResult) : void 0;
};

// src/components/utils/use-offers-inputs-context-hook.tsx
import React from "react";
var OffersInputsContext = React.createContext(void 0);
var useOffersInputsContext = () => {
  const context = React.useContext(OffersInputsContext);
  if (!context) {
    throw new Error("OffersInputsContext value is undefined");
  }
  return context;
};
var inputsReducer = (inputs, newInput) => __spreadValues(__spreadValues({}, inputs), newInput);

// src/components/utils/offer-details-card-initializer.tsx
var offerFilterInitializer = selections => {
  if (!selections) {
    return {};
  }
  return selections.reduce((filterMap, selection) => {
    var _a;
    switch (selection.__typename) {
      case "ActivityTravelerSelectorDialog":
        {
          const {
            ticketsStepInput
          } = selection;
          const travelerTicket = [];
          ticketsStepInput.forEach(step => {
            var _a2;
            const travlerData = {
              code: (_a2 = step.key) != null ? _a2 : "",
              count: step.value
            };
            travelerTicket.push(travlerData);
          });
          return __spreadProps(__spreadValues({}, filterMap), {
            tickets: travelerTicket
          });
        }
      case "ActivityRadioGroupDialog":
        {
          const {
            radioGroup: {
              groupName,
              selected
            }
          } = selection;
          const newSelections = (_a = filterMap.selections) != null ? _a : [];
          return __spreadProps(__spreadValues({}, filterMap), {
            selections: newSelections.concat({
              id: groupName,
              value: selected != null ? selected : ""
            })
          });
        }
      case "ActivityOfferSelectionGraphicText":
        {
          const {
            key,
            value
          } = selection;
          const newSelections = [...(filterMap.selections || [])];
          return __spreadProps(__spreadValues({}, filterMap), {
            selections: newSelections.concat({
              id: key,
              value
            })
          });
        }
      default:
        return filterMap;
    }
  }, {});
};
var offerDetailsCardInitializer = data => offerFilterInitializer(data.selections);

// src/components/offers/__private/__fragments/offers-summary/offers-summary.tsx
import React84 from "react";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign5 } from "@egds/react-core/price-lockup";
import { EGDSSheet as EGDSSheet7, EGDSSheetTransition as EGDSSheetTransition11 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing25, EGDSSpacingHr as EGDSSpacingHr5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11 } from "@egds/react-core/text";

// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
import React21 from "react";
import { EGDSDatePicker, EGDSDatePickerRenderType, EGDSDatePickerTriggeredSelector } from "@egds/react-core/date-picker";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { gql as gql27 } from "@shared-ui/apollo-client-wrapper";
import { useIdCompatibility as useIdCompatibility3 } from "@shared-ui/core-react-compatibility";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";

// ../internal/src/__fragments/common/date-fragment.ts
import { gql } from "@shared-ui/apollo-client-wrapper";
var __DateFragment = gql`
  fragment DateFragment on Date {
    day
    month
    year
  }
`;

// ../internal/src/__fragments/common/client-side-analytics.ts
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var clientSideAnalyticsFragment = gql2`
  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
`;

// ../internal/src/__fragments/common/car-rental-location.ts
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";
var __CarRentalLocation = gql3`
  fragment CarRentalLocationFragment on CarRentalLocation {
    airportCode
    coordinates {
      latitude
      longitude
    }
    isExactLocationSearch
    regionId
    searchTerm
  }
`;

// ../internal/src/__fragments/common/date-time.ts
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
var __DateTime = gql4`
  fragment DateTimeFragment on DateTime {
    day
    month
    year
    hour
    minute
    second
  }
`;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-toolbar.tsx
import React2 from "react";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var __Fragment = gql5`
  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {
    closeText
    title
  }
`;
var EGDSDialogToolbar = ({
  data,
  toolbarType,
  toolbarAction
}) => {
  var _a;
  return /* @__PURE__ */React2.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: toolbarAction,
      navType: toolbarType,
      navIconLabel: (_a = data.closeText) != null ? _a : void 0
    },
    toolbarTitle: data.title
  });
};
EGDSDialogToolbar.fragment = __Fragment;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";

// ../internal/src/components/activity-dialog/__private/__fragments/egds-travelers-step-input.tsx
import React3 from "react";
import { EGDSStepInput } from "@egds/react-core/step-input";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility } from "@shared-ui/core-react-compatibility";
var __Fragment2 = gql6`
  fragment EGDSTravelerStepInputFragment on EGDSStepInput {
    ... on EGDSTravelerStepInput {
      egdsElementId
      decreaseAnalytics {
        linkName
        referrerId
      }
      increaseAnalytics {
        linkName
        referrerId
      }
    }
    decreaseText
    increaseText
    label
    key
    max
    min
    step
    subLabel
    value
  }
`;
var EGDSTravelersStepInput = ({
  data,
  onChange,
  countIndex
}) => {
  const {
    decreaseText,
    increaseText,
    label,
    max,
    min,
    step,
    subLabel,
    value,
    key
  } = data;
  const [countValue, setCountValue] = React3.useState(value);
  const clickTracker = useClickTracker();
  const handleChange = event => {
    const stepValue = parseInt(event.target.value, 10);
    onChange(stepValue, key, countIndex);
    if (data.__typename === "EGDSTravelerStepInput") {
      if (stepValue > countValue) {
        clickTracker(data.increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
      } else {
        clickTracker(data.decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
      }
    }
    setCountValue(stepValue);
  };
  const travelerId = useIdCompatibility();
  return /* @__PURE__ */React3.createElement(EGDSStepInput, {
    label,
    incrementText: increaseText != null ? increaseText : "",
    decrementText: decreaseText != null ? decreaseText : "",
    incrementId: `${travelerId}-increase`,
    decrementId: `${travelerId}-decrease`,
    min: min != null ? min : 0,
    max: max != null ? max : 0,
    step,
    onChange: handleChange,
    value: countValue,
    description: subLabel != null ? subLabel : "",
    id: travelerId
  });
};
EGDSTravelersStepInput.displayName = "EGDSTravelersStepInput";
EGDSTravelersStepInput.fragment = __Fragment2;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
import React4 from "react";
import { EGDSDialogFooter } from "@egds/react-core/dialog";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer-button.ts
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDialogFooterButtonFragment = gql7`
  fragment EGDSDialogFooterButtonFragment on EGDSButton {
    primary
    accessibility
    disabled
  }
`;
var getButton = (data, closeDialog) => {
  var _a, _b, _c;
  switch (data.__typename) {
    case "UITertiaryButton":
      {
        return {
          text: (_a = data.primary) != null ? _a : "",
          type: "tertiary",
          onClick: closeDialog
        };
      }
    case "UIPrimaryButton":
      return {
        text: (_b = data.primary) != null ? _b : "",
        type: "primary",
        onClick: closeDialog
      };
    default:
      return {
        text: (_c = data.primary) != null ? _c : "",
        type: "primary",
        onClick: closeDialog
      };
  }
};

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
var __EGDSDialogFooterFragment = gql8`
  fragment EGDSDialogFooterFragment on EGDSDialogFooter {
    ... on EGDSInlineDialogFooter {
      buttons {
        ...EGDSDialogFooterButtonFragment
      }
    }
  }

  ${__EGDSDialogFooterButtonFragment}
`;
var ActivitiesEGDSDialogFooter = ({
  data,
  dialogActionMap,
  closeDialog
}) => {
  var _a, _b, _c;
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      {
        const {
          buttons
        } = data;
        const buttonMap = buttons.map((button, index) => {
          if (dialogActionMap && dialogActionMap.length > 1) {
            return __spreadValues(__spreadValues({}, getButton(button, closeDialog)), dialogActionMap[index]);
          }
          return __spreadValues({}, getButton(button, closeDialog));
        });
        return /* @__PURE__ */React4.createElement(EGDSDialogFooter, {
          buttonOne: (_a = buttonMap[0]) != null ? _a : void 0,
          buttonTwo: (_b = buttonMap[1]) != null ? _b : void 0,
          buttonThree: (_c = buttonMap[2]) != null ? _c : void 0
        });
      }
    default:
      return null;
  }
};
ActivitiesEGDSDialogFooter.displayName = "ActivitiesEGDSDialogFooter";
ActivitiesEGDSDialogFooter.fragment = __EGDSDialogFooterFragment;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-date-picker-content.ts
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDatePickerContentFragment = gql9`
  fragment EGDSDatePickerContentFragment on EGDSDatePickerContent {
    accessibility
    dateKey
    text
    theme
  }
`;
var getDatePickerContent = data => {
  const {
    accessibility,
    dateKey,
    text,
    theme
  } = data;
  return {
    [dateKey]: {
      text: text != null ? text : "",
      ariaLabel: accessibility != null ? accessibility : void 0,
      className: theme != null ? theme : void 0
    }
  };
};

// ../internal/src/components/activity-dialog/__private/activity-date-range-picker-dialog-helper.ts
import { DayName } from "@egds/react-core/date-picker";
var convertFromMiliSecondsToDays = miliseconds => Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
var convertToDateObject = ({
  year,
  month,
  day
}) => new Date(year, month - 1, day);
var EGDSDayNameMap = {
  ["SUN" /* SUN */]: DayName.SUN,
  ["MON" /* MON */]: DayName.MON,
  ["TUE" /* TUE */]: DayName.TUE,
  ["WED" /* WED */]: DayName.WED,
  ["THU" /* THU */]: DayName.THU,
  ["FRI" /* FRI */]: DayName.FRI,
  ["SAT" /* SAT */]: DayName.SAT
};

// ../internal/src/components/activity-dialog/activity-dialog-trigger.tsx
import React20 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSFakeInput } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { gql as gql26 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button.tsx
import React19 from "react";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { gql as gql25 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button-action.ts
import { gql as gql24 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-heading.tsx
import React5 from "react";
import { EGDSHeading } from "@egds/react-core/text";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};

// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql10`
  fragment EGDSHeadingFragment on EGDSHeading {
    text
    headingType
    accessibility
  }
`;
var ActivitiesEGDSHeading = ({
  className,
  align,
  size,
  tag,
  data,
  tabIndex
}) => {
  const {
    headingType,
    text,
    accessibility
  } = data;
  const headingTag = tag != null ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, /* @__PURE__ */React5.createElement(EGDSHeading, {
    className,
    align,
    tag: tag != null ? tag : headingTag,
    size,
    tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React5.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
ActivitiesEGDSHeading.fragment = fragment;
ActivitiesEGDSHeading.displayName = "ActivitiesEGDSHeading";

// ../internal/src/components/egds-text/egds-paragraph.tsx
import React6 from "react";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};

// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql11`
  fragment EGDSParagraphFragment on EGDSParagraph {
    text
    style
  }
`;
var ActivitiesEGDSParagraph = ({
  className,
  data
}) => {
  const {
    text,
    style
  } = data;
  return /* @__PURE__ */React6.createElement(EGDSParagraph, {
    className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
ActivitiesEGDSParagraph.fragment = fragment2;
ActivitiesEGDSParagraph.displayName = "ActivitiesEGDSParagraph";

// ../internal/src/components/egds-text/egds-standard-link.tsx
import React10 from "react";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React7 from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
import { useIdCompatibility as useIdCompatibility2 } from "@shared-ui/core-react-compatibility";
var __EGDSIconFragment = gql12`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    theme
    title
    withBackground
  }
`;
var ActivitiesEGDSIcon = ({
  className,
  data
}) => {
  var _a, _b;
  const iconId = useIdCompatibility2();
  return /* @__PURE__ */React7.createElement(EGDSIcon, {
    className,
    description: data.description,
    id: iconId,
    name: data.id,
    size: data.size ? EGDSIconSize[data.size] : void 0,
    title: (_a = data.title) != null ? _a : void 0,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    shadow: Boolean(data.withBackground)
  });
};
ActivitiesEGDSIcon.displayName = "ActivitiesEGDSIcon";
ActivitiesEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-mark.tsx
import React8 from "react";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";
var __EGDSMarkFragment = gql13`
  fragment EGDSMarkFragment on Mark {
    description
    id
    markSize: size
    url {
      ... on HttpURI {
        __typename
        relativePath
        value
      }
    }
  }
`;
var ActivitiesEGDSMark = ({
  className,
  data
}) => {
  var _a;
  return /* @__PURE__ */React8.createElement(EGDSMark, {
    className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? EGDSMarkSize[data.markSize] : void 0,
    url: (_a = data.url) == null ? void 0 : _a.value
  });
};
ActivitiesEGDSMark.displayName = "ActivitiesEGDSMark";
ActivitiesEGDSMark.fragment = __EGDSMarkFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React9 from "react";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql14`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }

    ... on Mark {
      ...EGDSMarkFragment
    }
  }

  ${ActivitiesEGDSIcon.fragment}
  ${ActivitiesEGDSMark.fragment}
`;
var EGDSGraphic = ({
  className,
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React9.createElement(ActivitiesEGDSIcon, {
        className,
        data
      });
    case "Mark":
      return /* @__PURE__ */React9.createElement(ActivitiesEGDSMark, {
        className,
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = {
  ["SMALL" /* SMALL */]: "small",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["LARGE" /* LARGE */]: "large"
};
var UILinkTargetMap = {
  ["EXTERNAL" /* EXTERNAL */]: "_blank",
  ["INTERNAL" /* INTERNAL */]: "_self"
};

// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql15`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
        ... on HttpURI {
          relativePath
        }
      }
      target
      useRelativePath
    }
    disabled
    standardLinkIcon: icon {
      ...EGDSIconFragment
    }
    iconPosition
    size
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var IconPlacement = ({
  icon,
  iconPosition,
  iconPositionToMatch
}) => {
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React10.createElement(ActivitiesEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = ({
  className,
  inline,
  align,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility,
      useRelativePath
    },
    disabled,
    iconPosition,
    standardLinkIcon,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker2();
  const onClick = React10.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  const getPath = React10.useCallback(() => {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React10.createElement(EGDSLink, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline,
    disabled,
    align
  }, /* @__PURE__ */React10.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React10.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React10.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React10.createElement(EGDSText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";

// ../internal/src/components/egds-text/egds-text.tsx
import React18 from "react";
import { gql as gql23 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React11 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
var fragment4 = gql16`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...EGDSGraphicFragment
    }
    text
  }

  ${EGDSGraphic.fragment}
`;
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = ({
  className,
  size,
  data
}) => {
  const {
    graphic,
    text
  } = data;
  return /* @__PURE__ */React11.createElement(EGDSLayoutFlex, {
    className
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React11.createElement(EGDSSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React11.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React11.createElement(EGDSSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React11.createElement(EGDSText2, {
    size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";

// ../internal/src/components/egds-text/egds-icon-text.tsx
import React12 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql17`
  fragment EGDSIconTextFragment on EGDSIconText {
    icon {
      ...EGDSIconFragment
    }
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = ({
  className,
  size,
  data
}) => {
  const {
    icon,
    text
  } = data;
  return /* @__PURE__ */React12.createElement(EGDSLayoutFlex2, {
    className
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React12.createElement(ActivitiesEGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React12.createElement(EGDSSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React12.createElement(EGDSText3, {
    size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";

// ../internal/src/components/egds-text/egds-inline-link.tsx
import React13 from "react";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { gql as gql18 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment6 = gql18`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    disabled
    size
    text
  }
`;
var EGDSInlineLink = ({
  className,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility
    },
    disabled,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker3();
  const onClick = React13.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React13.createElement(EGDSLink2, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled,
    inline: true
  }, /* @__PURE__ */React13.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React13.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React14 from "react";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql19 } from "@shared-ui/apollo-client-wrapper";
var fragment7 = gql19`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  className,
  inline,
  align,
  size,
  theme,
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React14.createElement(EGDSText4, {
    whiteSpace: "pre-line",
    className,
    align,
    size,
    inline,
    theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React17 from "react";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
import { gql as gql22 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React16 from "react";
import { gql as gql21 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React15 from "react";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql20 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = {
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["PRIMARY" /* PRIMARY */]: "emphasis",
  ["SECONDARY" /* SECONDARY */]: "default",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["INVERSE" /* INVERSE */]: "inverse"
};
var EGDSTextThemeMapper = {
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["DEFAULT" /* DEFAULT */]: "default"
};

// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = {
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
};

// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql20`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    theme
    weight
    accessibility
    decorative
    textSize: size
  }
`;
var EGDSStylizedText = ({
  className,
  inline,
  align,
  size,
  data
}) => {
  const {
    text,
    theme,
    weight,
    accessibility,
    decorative
  } = data;
  const themeProps = theme ? textThemeMapper[theme] : void 0;
  const weightProps = weight ? textWeightMapper[weight] : void 0;
  const RenderText = () => /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(EGDSText5, {
    className,
    align,
    inline,
    size,
    theme: themeProps,
    weight: weightProps,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React15.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React15.createElement("s", null, /* @__PURE__ */React15.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React15.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql21`
  fragment EGDSSpannableTextContentFragment on EGDSText {
    ...EGDSStylizedTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSPlainTextFragment
  }

  ${EGDSStylizedText.fragment}
  ${EGDSGraphicText.fragment}
  ${EGDSPlainText.fragment}
`;
var EGDSSpannableTextContent = ({
  className,
  size,
  align,
  theme,
  data
}) => {
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React16.createElement(EGDSStylizedText, {
        className,
        data,
        size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React16.createElement(EGDSGraphicText, {
        className,
        data,
        size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React16.createElement(EGDSPlainText, {
        className,
        data,
        size,
        align,
        inline: true,
        theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql22`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    text
    contents {
      ...EGDSSpannableTextContentFragment
    }
    inlineContent {
      ...EGDSSpannableTextContentFragment
    }
  }

  ${EGDSSpannableTextContent.fragment}
`;
var EGDSSpannableText = props => {
  var _b, _c, _d;
  const _a = props,
    {
      align,
      headingSize,
      data,
      theme
    } = _a,
    styleProps = __objRest(_a, ["align", "headingSize", "data", "theme"]);
  if (((_b = data == null ? void 0 : data.contents) == null ? void 0 : _b.length) === 0 && !((_c = data == null ? void 0 : data.inlineContent) == null ? void 0 : _c.length)) {
    return /* @__PURE__ */React17.createElement(EGDSText6, __spreadProps(__spreadValues({}, styleProps), {
      inline: true,
      align,
      theme
    }), data.text);
  }
  if ((_d = data == null ? void 0 : data.inlineContent) == null ? void 0 : _d.length) {
    return /* @__PURE__ */React17.createElement(React17.Fragment, null, data.inlineContent.map((item, index) => /* @__PURE__ */React17.createElement(React17.Fragment, null, /* @__PURE__ */React17.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
      align,
      data: item
    }, styleProps), {
      key: `spannable-item-${index}`,
      theme
    })), " ")));
  }
  return /* @__PURE__ */React17.createElement(React17.Fragment, null, data.contents.map((item, index) => /* @__PURE__ */React17.createElement(React17.Fragment, {
    key: `spannable-item-${index}`
  }, /* @__PURE__ */React17.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
    data: item
  }, styleProps), {
    headingSize,
    theme
  })), " ")));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql23`
  fragment EGDSTextFragment on EGDSText {
    ...EGDSHeadingFragment
    ...EGDSPlainTextFragment
    ...EGDSStylizedTextFragment
    ...EGDSIconTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSParagraphFragment
    ...EGDSStandardLinkFragment
    ...EGDSInlineLinkFragment
    ...EGDSSpannableTextFragment
  }

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
  ${EGDSStylizedText.fragment}
  ${EGDSIconText.fragment}
  ${EGDSGraphicText.fragment}
  ${ActivitiesEGDSParagraph.fragment}
  ${EGDSStandardLink.fragment}
  ${EGDSInlineLink.fragment}
  ${EGDSSpannableText.fragment}
`;
var ActivitiesEGDSText = ({
  className,
  headingAlign,
  headingSize,
  headingTag,
  textAlign,
  textSize,
  align,
  inline,
  tabIndex,
  theme,
  data
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React18.createElement(ActivitiesEGDSHeading, {
        className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data,
        tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React18.createElement(EGDSPlainText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline,
        theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React18.createElement(EGDSStylizedText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React18.createElement(EGDSGraphicText, {
        className,
        size: textSize,
        data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React18.createElement(EGDSIconText, {
        className,
        size: textSize,
        data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React18.createElement(ActivitiesEGDSParagraph, {
        className,
        data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React18.createElement(EGDSStandardLink, {
        className,
        data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React18.createElement(EGDSInlineLink, {
        className,
        data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React18.createElement(EGDSSpannableText, {
        className,
        size: textSize,
        headingSize,
        data,
        align,
        theme
      });
    default:
      return null;
  }
};
ActivitiesEGDSText.fragment = fragment11;
ActivitiesEGDSText.displayName = "ActivitiesEGDSText";

// ../internal/src/components/egds-button/egds-button-action.ts
var __EGDSButtonActionFragment = gql24`
  fragment EGDSButtonActionFragment on UIAction {
    analytics {
      linkName
      referrerId
    }

    ... on ActivityOpenOffersModalAction {
      activityId
      dateRange {
        startDate {
          day
          month
          year
        }
        endDate {
          day
          month
          year
        }
      }
      dismissButtonAccessibility
      dismissButtonAnalytics {
        linkName
        referrerId
      }
      selectedOffers {
        offerProductNaturalKey
      }
      heading {
        ...EGDSHeadingFragment
      }
      subHeading {
        ...EGDSPlainTextFragment
      }
      travelers {
        ...ActivityTravelerDetailsFragment
      }
    }

    ... on ActivityAddOfferToTripAction {
      callbackMessages {
        failure
        success
      }
      offerNaturalKey {
        offerProductNaturalKey
      }
    }

    ... on ActivityRemoveOffersFromTripAction {
      callbackMessages {
        failure
        success
      }
      offerNaturalKeys {
        offerProductNaturalKey
      }
    }

    ... on ActivityUpdateOfferInTripAction {
      callbackMessages {
        failure
        success
      }
      newOfferNaturalKey {
        offerProductNaturalKey
      }
      oldOfferNaturalKey {
        offerProductNaturalKey
      }
    }
  }
  fragment ActivityTravelerDetailsFragment on ActivityTravelerDetails {
    age
    count
  }

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
`;

// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql25`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    accessibility
    disabled
    action {
      ...EGDSButtonActionFragment
    }
    icon {
      description
      id
      title
    }
  }

  ${__EGDSButtonActionFragment}
`;
var ActivitiesEGDSButton = ({
  analytics,
  className,
  domRef,
  href,
  isFullWidth,
  onClickHandler,
  size,
  data
}) => {
  var _a;
  const {
    __typename,
    accessibility,
    action,
    primary,
    disabled,
    icon
  } = data;
  const clickTracker = useClickTracker4();
  const analyticsButton = action ? {
    description: action.analytics.linkName,
    id: action.analytics.referrerId,
    callback: (referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }
  } : void 0;
  const handleOnClick = React19.useCallback(() => {
    onClickHandler == null ? void 0 : onClickHandler();
  }, [onClickHandler]);
  if (!primary) {
    return null;
  }
  const buttonProps = {
    analytics: analytics || analyticsButton,
    "aria-label": accessibility != null ? accessibility : void 0,
    className,
    disabled,
    href,
    isFullWidth,
    onClick: handleOnClick,
    size,
    domRef
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React19.createElement(EGDSPrimaryButton, __spreadValues({}, buttonProps), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React19.createElement(EGDSSecondaryButton, __spreadValues({}, buttonProps), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React19.createElement(EGDSTertiaryButton, __spreadValues({}, buttonProps), primary);
    case "EGDSOverlayButton":
      return /* @__PURE__ */React19.createElement(EGDSOverlayButton, __spreadValues({}, buttonProps), icon && /* @__PURE__ */React19.createElement(EGDSIcon2, {
        name: (_a = icon == null ? void 0 : icon.id) != null ? _a : ""
      }), primary);
    default:
      return null;
  }
};
ActivitiesEGDSButton.fragment = _Fragment;
ActivitiesEGDSButton.displayName = "ActivitiesEGDSButton";

// ../internal/src/components/activity-dialog/activity-dialog-trigger.tsx
var __Fragment3 = gql26`
  fragment ActivityDialogTriggerFragment on ActivityDialogTrigger {
    accessibility
    analytics {
      linkName
      referrerId
    }

    ... on ActivityButtonDialogTrigger {
      button {
        ...EGDSButtonFragment
      }
    }

    ... on ActivityGraphicDialogTrigger {
      graphic {
        ...EGDSGraphicFragment
      }
    }

    ... on ActivityLinkDialogTrigger {
      linkGraphic: graphic {
        ...EGDSGraphicFragment
      }
      label
    }

    ... on ActivityFakeInputDialogTrigger {
      icon {
        id
      }
      label
      value
    }

    ... on ActivityMapDialogTrigger {
      staticMapImage {
        accessibility
        url
      }
      mapTriggerLabel: label
    }
  }

  ${EGDSGraphic.fragment}
  ${ActivitiesEGDSButton.fragment}
`;
var ActivityDialogTrigger = ({
  className,
  data,
  domRef,
  linkIconPosition = "TRAILING" /* TRAILING */,
  openDialog,
  autoFocus
}) => {
  var _a, _b, _c;
  const {
    accessibility,
    analytics
  } = data;
  const clickTracker = useClickTracker5();
  const analyticsDialogTrigger = {
    description: analytics.linkName,
    id: analytics.referrerId,
    callback: React20.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const trackAnalytics = React20.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [analytics, clickTracker]);
  switch (data.__typename) {
    case "ActivityButtonDialogTrigger":
      return /* @__PURE__ */React20.createElement(ActivitiesEGDSButton, {
        analytics: analyticsDialogTrigger,
        size: EGDSButtonSize.MEDIUM,
        onClickHandler: openDialog,
        domRef,
        data: data.button
      });
    case "ActivityGraphicDialogTrigger":
      return /* @__PURE__ */React20.createElement(EGDSMoreInfoTrigger, {
        className,
        analytics: analyticsDialogTrigger,
        onClick: openDialog,
        size: "small"
      }, /* @__PURE__ */React20.createElement("button", {
        ref: domRef,
        type: "button"
      }, /* @__PURE__ */React20.createElement(EGDSGraphic, {
        data: data.graphic
      }), /* @__PURE__ */React20.createElement("span", {
        className: "is-visually-hidden"
      }, accessibility)));
    case "ActivityFakeInputDialogTrigger":
      return /* @__PURE__ */React20.createElement("div", {
        className
      }, /* @__PURE__ */React20.createElement(EGDSFakeInput, {
        domRef,
        label: data.label,
        value: (_a = data.value) != null ? _a : "",
        icon: (_b = data.icon) == null ? void 0 : _b.id,
        onChange: openDialog,
        onClick: openDialog,
        analytics: analyticsDialogTrigger,
        autoFocus
      }));
    case "ActivityLinkDialogTrigger":
      return /* @__PURE__ */React20.createElement(EGDSLink3, {
        className,
        onClick: openDialog,
        onClickCapture: trackAnalytics,
        size: "medium"
      }, /* @__PURE__ */React20.createElement("button", {
        ref: domRef,
        type: "button"
      }, data.linkGraphic && linkIconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React20.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), data.label, data.linkGraphic && linkIconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React20.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), /* @__PURE__ */React20.createElement("span", {
        className: "is-visually-hidden",
        "aria-hidden": data.label === accessibility
      }, accessibility)));
    case "ActivityMapDialogTrigger":
      return /* @__PURE__ */React20.createElement(EGDSLayoutFlex3, {
        className
      }, /* @__PURE__ */React20.createElement(EGDSLink3, {
        onClickCapture: trackAnalytics
      }, /* @__PURE__ */React20.createElement("button", {
        ref: domRef,
        type: "button",
        onClick: openDialog,
        "aria-labelledby": accessibility
      }, /* @__PURE__ */React20.createElement(EGDSLayoutFlexItem3, {
        minWidth: "full_width"
      }, /* @__PURE__ */React20.createElement(EGDSCard, {
        border: true
      }, ((_c = data.staticMapImage) == null ? void 0 : _c.url) && /* @__PURE__ */React20.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R21_9
      }, /* @__PURE__ */React20.createElement(EGDSImage, {
        src: data.staticMapImage.url,
        alt: data.staticMapImage.accessibility || ""
      })), data.mapTriggerLabel && /* @__PURE__ */React20.createElement(EGDSCardContentSection, null, /* @__PURE__ */React20.createElement(EGDSLayoutFlex3, {
        justifyContent: "center"
      }, data.mapTriggerLabel)))))));
    default:
      return null;
  }
};
ActivityDialogTrigger.displayName = "ActivityDialogTrigger";
ActivityDialogTrigger.fragment = __Fragment3;

// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
var __Fragment4 = gql27`
  fragment ActivityDateRangePickerDialogFragment on ActivityDateRangePickerDialog {
    dateRangePicker {
      buttonText
      dateFormat
      firstDayOfWeek
      footerText
      sameDaySelectionAllowed
      selectedEndDate {
        ...DateFragment
      }
      selectedStartDate {
        ...DateFragment
      }
      validDaysLowerBoundInclusive {
        ...DateFragment
      }
      validDaysUpperBoundInclusive {
        ...DateFragment
      }
      datePickerContent {
        ...EGDSDatePickerContentFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${__EGDSDatePickerContentFragment}
  ${__DateFragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityDateRangePickerDialog = ({
  className,
  onSubmitHandler,
  data,
  isNestedDialog
}) => {
  const {
    formatDateString
  } = useLocalization();
  const dialogKey = useIdCompatibility3();
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog(`activity-date-range-picker-dialog-${dialogKey}`, nestedDialogKey);
  const {
    dateRangePicker: {
      buttonText,
      firstDayOfWeek,
      footerText,
      sameDaySelectionAllowed,
      selectedEndDate,
      selectedStartDate,
      validDaysLowerBoundInclusive,
      validDaysUpperBoundInclusive,
      dateFormat,
      datePickerContent
    },
    trigger
  } = data;
  const today = /* @__PURE__ */new Date();
  const tomorrow = /* @__PURE__ */new Date();
  tomorrow.setDate(today.getDate() + 1);
  const defaultDaysBookableInAdvance = 500;
  const dateRangePickerTrigger = React21.createRef();
  const [startDate, setStartDate] = React21.useState(formatDateString(today, {
    raw: dateFormat
  }));
  const [endDate, setEndDate] = React21.useState(formatDateString(tomorrow, {
    raw: dateFormat
  }));
  const [validStartDate, setValidStartDate] = React21.useState(formatDateString(today, {
    raw: dateFormat
  }));
  const [daysBookableInAdvance, setDaysBookableInAdvance] = React21.useState(defaultDaysBookableInAdvance);
  const [datePickerContentMap, setDatePickerContentMap] = React21.useState(void 0);
  React21.useEffect(() => {
    const dateFormatOptions = {
      raw: dateFormat
    };
    if (selectedStartDate) {
      setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
    }
    if (selectedEndDate) {
      setEndDate(formatDateString(convertToDateObject(selectedEndDate), dateFormatOptions));
    }
    if (validDaysLowerBoundInclusive) {
      setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
    }
    if (validDaysUpperBoundInclusive) {
      const difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - (/* @__PURE__ */new Date()).getTime();
      setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
    }
    if (datePickerContent == null ? void 0 : datePickerContent.length) {
      const newDatePickerContent = datePickerContent.reduce((contentMap, content) => __spreadValues(__spreadValues({}, contentMap), getDatePickerContent(content)), {});
      setDatePickerContentMap(newDatePickerContent);
    }
  }, [formatDateString, selectedEndDate, selectedStartDate, validDaysLowerBoundInclusive, validDaysUpperBoundInclusive, dateFormat, datePickerContent]);
  const onDismissCB = React21.useCallback(() => {
    dialogActions.closeDialog();
    if (dateRangePickerTrigger.current && typeof dateRangePickerTrigger.current.focus === "function") {
      dateRangePickerTrigger.current.focus();
    }
  }, [dialogActions, dateRangePickerTrigger]);
  const onSubmitCB = React21.useCallback((start, end) => {
    const newEndDate = end || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
    const startDateFormatted = formatDateString(start, {
      raw: dateFormat
    });
    const endDateFormatted = formatDateString(newEndDate, {
      raw: dateFormat
    });
    setStartDate(startDateFormatted);
    setEndDate(endDateFormatted);
    onSubmitHandler(startDateFormatted, endDateFormatted);
    onDismissCB();
  }, [dateFormat, formatDateString, onDismissCB, onSubmitHandler]);
  const dateFieldProps = {
    showDatePicker: true,
    useCustomTrigger: true
  };
  const datePickerProps = {
    buttonText,
    dateFieldProps,
    datePickerContent: datePickerContentMap,
    daysBookableInAdvance,
    doubleMonths: true,
    endDate,
    firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
    footerText: footerText != null ? footerText : void 0,
    onDismissCB,
    onSubmitCB,
    renderType: EGDSDatePickerRenderType.DIALOG,
    singleDateSelect: sameDaySelectionAllowed,
    startDate,
    triggeredSelector: EGDSDatePickerTriggeredSelector.START,
    validStartDate
  };
  return /* @__PURE__ */React21.createElement(React21.Fragment, null, /* @__PURE__ */React21.createElement(ActivityDialogTrigger, {
    className,
    domRef: dateRangePickerTrigger,
    linkIconPosition: "LEADING" /* LEADING */,
    openDialog: dialogActions.openDialog,
    data: trigger
  }), /* @__PURE__ */React21.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React21.createElement(DialogComponent, null, /* @__PURE__ */React21.createElement(EGDSDatePicker, __spreadValues({}, datePickerProps)))));
};
ActivityDateRangePickerDialog.displayName = "ActivityDateRangePickerDialog";
ActivityDateRangePickerDialog.fragment = __Fragment4;

// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
import React22 from "react";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { gql as gql29 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility4 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";

// ../internal/src/components/actions/activity-click-action.ts
import { gql as gql28 } from "@shared-ui/apollo-client-wrapper";
var __ActivityClickActionsFragment = gql28`
  fragment ActivityClickActionsFragment on ActivityClickAction {
    accessibilityText
    clientSideAnalytics {
      linkName
      referrerId
    }
    ... on ActivityLinkClickAction {
      linkTagUrl
      opensInNewTab
    }

    ... on ActivityRefClickAction {
      sectionRef
    }

    ... on ActivitySelectionClickAction {
      selectionList {
        id
        value
      }
    }
    ... on ActivityPaginationInfoAction {
      pagination {
        size
        startingIndex
      }
    }
  }
`;
var getClickAction = (data, clickTracker, closeDialog) => {
  switch (data.__typename) {
    case "ActivityLinkClickAction":
      {
        const linkDialog = () => {
          const {
            clientSideAnalytics,
            linkTagUrl,
            opensInNewTab
          } = data;
          clickTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
          if (linkTagUrl) {
            window.open(linkTagUrl, opensInNewTab ? "_blank" : "_self");
          }
        };
        return {
          onClick: linkDialog
        };
      }
    case "ActivityRefClickAction":
      return {
        href: `#${data.sectionRef}`
      };
    case "ActivityCloseDialogClickAction":
      return {
        onClick: closeDialog
      };
    case "ActivitySelectionClickAction":
      {
        const tabSelection = () => {
          const {
            clientSideAnalytics,
            selectionList
          } = data;
          clickTracker(clientSideAnalytics == null ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics == null ? void 0 : clientSideAnalytics.linkName);
          if (selectionList) {
            return selectionList;
          }
        };
        return {
          selectedTabAction: tabSelection()
        };
      }
    case "ActivityPaginationInfoAction":
      {
        const {
          clientSideAnalytics,
          pagination
        } = data;
        clickTracker(clientSideAnalytics == null ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics == null ? void 0 : clientSideAnalytics.linkName);
        return {
          paginatedIndex: pagination
        };
      }
    default:
      return null;
  }
};

// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
var __Fragment5 = gql29`
  fragment ActivityDisclaimerDialogFragment on ActivityDisclaimerDialog {
    contents {
      ...EGDSTextFragment
    }
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      footer {
        ...EGDSDialogFooterFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    dialogActions {
      ...ActivityClickActionsFragment
    }
  }

  ${__ActivityClickActionsFragment}
  ${ActivityDialogTrigger.fragment}

  ${__EGDSDialogFooterFragment}
  ${ActivitiesEGDSText.fragment}
`;
var ActivityDisclaimerDialog = ({
  className,
  data,
  dialogIdSuffix,
  linkIconPosition
}) => {
  const {
    contents,
    dialog,
    trigger,
    dialogActions
  } = data;
  const clickTracker = useClickTracker6();
  const randomDialogKey = useIdCompatibility4();
  const dialogKey = dialogIdSuffix != null ? dialogIdSuffix : randomDialogKey;
  const [isDialogOpen, dialogComponentActions, DialogComponent] = useDialog2(`activity-disclaimer-dialog-${dialogKey}`, "nestedActivityDisclaimerDialog");
  const dialogActionMap = dialogActions == null ? void 0 : dialogActions.map(dialogAction => getClickAction(dialogAction, clickTracker, dialogComponentActions.closeDialog));
  const activityLinkDialogTrigger = React22.createRef();
  const closeDialog = React22.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    if (activityLinkDialogTrigger.current && typeof activityLinkDialogTrigger.current.focus === "function") {
      activityLinkDialogTrigger.current.focus();
    }
    dialogComponentActions.closeDialog();
  }, [dialogComponentActions, clickTracker, dialog.closeAnalytics]);
  return /* @__PURE__ */React22.createElement(React22.Fragment, null, /* @__PURE__ */React22.createElement(ActivityDialogTrigger, {
    className,
    domRef: activityLinkDialogTrigger,
    openDialog: dialogComponentActions.openDialog,
    data: trigger,
    linkIconPosition
  }), /* @__PURE__ */React22.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React22.createElement(DialogComponent, null, /* @__PURE__ */React22.createElement(EGDSDialog, {
    dialogShow: isDialogOpen,
    ariaLabel: trigger.accessibility,
    returnFocusOnClose: true
  }, /* @__PURE__ */React22.createElement(EGDSDialogContent, null, contents.map((content, index) => /* @__PURE__ */React22.createElement(ActivitiesEGDSText, {
    key: `disclaimer-dialog-contents-${index}`,
    data: content
  })), /* @__PURE__ */React22.createElement(ActivitiesEGDSDialogFooter, {
    data: dialog.footer,
    dialogActionMap,
    closeDialog
  }))))));
};
ActivityDisclaimerDialog.displayName = "ActivityDisclaimerDialog";
ActivityDisclaimerDialog.fragment = __Fragment5;

// ../internal/src/components/activity-dialog/activity-traveler-selection-dialog.tsx
import React23 from "react";
import { EGDSButtonSize as EGDSButtonSize2, EGDSFloatingFullWidthButton } from "@egds/react-core/button";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { gql as gql30 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility5 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var __Fragment6 = gql30`
  fragment ActivityTravelerSelectorDialogFragment on ActivityTravelerSelectorDialog {
    heading {
      ...EGDSHeadingFragment
    }
    doneButton {
      primary
      action {
        analytics {
          linkName
          referrerId
        }
      }
    }
    ticketsStepInput {
      ...EGDSTravelerStepInputFragment
    }
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    errorMessageForSelectedTickets {
      ...EGDSGraphicTextFragment
    }
  }

  ${ActivityDialogTrigger.fragment}

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSTravelersStepInput.fragment}
  ${EGDSDialogToolbar.fragment}
  ${EGDSGraphicText.fragment}
`;
var headingMargin = {
  blockend: "two"
};
var ActivityTravelerSelectorDialog = ({
  className,
  doneClickHandler,
  data,
  isNestedDialog,
  autoFocus
}) => {
  const clickTracker = useClickTracker7();
  const {
    heading,
    dialog,
    doneButton,
    ticketsStepInput,
    trigger,
    errorMessageForSelectedTickets
  } = data;
  const [ticket, setTicketValue] = React23.useState();
  const randomDialogKey = useIdCompatibility5();
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog3(`activity-traveler-selection-dialog-${randomDialogKey}`, nestedDialogKey);
  const triggerRef = React23.useRef(null);
  const [isDoneButtonDisabled, setIsDoneButtonDisabled] = React23.useState(false);
  const intialTickets = React23.useMemo(() => {
    const travelerTicket = [];
    ticketsStepInput.forEach(step => {
      var _a;
      const travlerData = {
        code: (_a = step.key) != null ? _a : "",
        count: step.value
      };
      travelerTicket.push(travlerData);
    });
    setTicketValue(travelerTicket);
    return travelerTicket;
  }, [ticketsStepInput]);
  const onTravelerSelector = React23.useCallback((value, key, countIndex) => {
    intialTickets[countIndex] = {
      code: key != null ? key : "",
      count: value
    };
    setTicketValue(intialTickets);
    const atLeastOneTicketCount = intialTickets.find(t => t.count > 0);
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
  }, [intialTickets]);
  const closeToolbarAction = React23.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialog.closeAnalytics, clickTracker]);
  const onClick = React23.useCallback(() => {
    var _a;
    doneClickHandler(ticket != null ? ticket : []);
    if ((_a = doneButton.action) == null ? void 0 : _a.analytics) {
      clickTracker(doneButton.action.analytics.referrerId, doneButton.action.analytics.linkName);
    }
    dialogActions.closeDialog();
  }, [doneClickHandler, ticket]);
  const openDialog = React23.useCallback(() => {
    const atLeastOneTicketCount = ticketsStepInput.find(t => t.value > 0);
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
    dialogActions.openDialog();
  }, []);
  const renderTravelerSelectionDialog = viewportType => /* @__PURE__ */React23.createElement(EGDSSheet, {
    type: viewportType,
    isVisible: true,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React23.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: closeToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React23.createElement(EGDSSheetContent, null, heading && /* @__PURE__ */React23.createElement(EGDSSpacing3, {
    margin: headingMargin
  }, /* @__PURE__ */React23.createElement(ActivitiesEGDSHeading, {
    size: 6,
    data: heading
  })), ticketsStepInput.map((count, index) => /* @__PURE__ */React23.createElement(EGDSTravelersStepInput, {
    key: index,
    countIndex: index,
    onChange: onTravelerSelector,
    data: count
  })), /* @__PURE__ */React23.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "three"
    }
  }, isDoneButtonDisabled && errorMessageForSelectedTickets ? /* @__PURE__ */React23.createElement(EGDSGraphicText, {
    data: errorMessageForSelectedTickets
  }) : /* @__PURE__ */React23.createElement("div", null, "\xA0")), /* @__PURE__ */React23.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React23.createElement(EGDSFloatingFullWidthButton, {
    size: EGDSButtonSize2.LARGE,
    onClick,
    disabled: isDoneButtonDisabled
  }, doneButton.primary))));
  return /* @__PURE__ */React23.createElement(React23.Fragment, null, /* @__PURE__ */React23.createElement(ActivityDialogTrigger, {
    className,
    openDialog,
    data: trigger,
    domRef: triggerRef,
    autoFocus
  }), /* @__PURE__ */React23.createElement(EGDSSheetTransition3, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React23.createElement(DialogComponent, null, /* @__PURE__ */React23.createElement(Viewport, null, /* @__PURE__ */React23.createElement(ViewSmall, null, renderTravelerSelectionDialog("full" /* FULL_SCREEN */)), /* @__PURE__ */React23.createElement(ViewMedium, null, renderTravelerSelectionDialog("centered" /* CENTERED */))))));
};
ActivityTravelerSelectorDialog.displayName = "ActivityTravelerSelectorDialog";
ActivityTravelerSelectorDialog.fragment = __Fragment6;

// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
import React27 from "react";
import { EGDSButtonSize as EGDSButtonSize3, EGDSFloatingFullWidthButton as EGDSFloatingFullWidthButton2 } from "@egds/react-core/button";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { gql as gql34 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility6 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";

// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
import React26 from "react";
import { EGDSRadioButtonGroup } from "@egds/react-core/radio-button";
import { gql as gql33 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
import React25 from "react";
import { gql as gql32 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-radio-group/egds-basic-radio-button.tsx
import React24 from "react";
import { EGDSRadioButton } from "@egds/react-core/radio-button";
import { gql as gql31 } from "@shared-ui/apollo-client-wrapper";
var __Fragment7 = gql31`
  fragment EGDSBasicRadioButtonFragment on EGDSBasicRadioButton {
    description
    disabled
    label
    labelSuffix
    value
  }
`;
var EGDSBasicRadioButton = ({
  data,
  groupName
}) => {
  const {
    description,
    disabled,
    label,
    labelSuffix,
    value
  } = data;
  return /* @__PURE__ */React24.createElement(EGDSRadioButton, {
    key: `${groupName}-${value}`,
    disabled,
    id: value,
    value,
    description: description != null ? description : void 0,
    label,
    labelSuffix: labelSuffix != null ? labelSuffix : void 0
  });
};
EGDSBasicRadioButton.displayName = "EGDSBasicRadioButton";
EGDSBasicRadioButton.fragment = __Fragment7;

// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
var _Fragment2 = gql32`
  fragment EGDSRadioButtonFragment on EGDSRadioButton {
    ... on EGDSBasicRadioButton {
      ...EGDSBasicRadioButtonFragment
    }
  }

  ${EGDSBasicRadioButton.fragment}
`;
var ActivitiesEGDSRadioButton = ({
  data,
  groupName
}) => {
  switch (data.__typename) {
    case "EGDSBasicRadioButton":
      return /* @__PURE__ */React25.createElement(EGDSBasicRadioButton, {
        groupName,
        data
      });
    default:
      return null;
  }
};
ActivitiesEGDSRadioButton.displayName = "ActivitiesEGDSRadioButton";
ActivitiesEGDSRadioButton.fragment = _Fragment2;

// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
var __Fragment8 = gql33`
  fragment EGDSBasicRadioGroupFragment on EGDSBasicRadioGroup {
    groupName
    selected
    options {
      ...EGDSRadioButtonFragment
    }
  }

  ${ActivitiesEGDSRadioButton.fragment}
`;
var EGDSBasicRadioGroup = ({
  data,
  onChange
}) => {
  const {
    groupName,
    selected,
    options
  } = data;
  return /* @__PURE__ */React26.createElement(EGDSRadioButtonGroup, {
    group: groupName,
    onChange,
    selected: selected != null ? selected : void 0,
    defaultChecked: true
  }, options.map((option, index) => /* @__PURE__ */React26.createElement(ActivitiesEGDSRadioButton, {
    key: `egds-radio-group-${index}`,
    data: option,
    groupName
  })));
};
EGDSBasicRadioGroup.displayName = "EGDSBasicRadioGroup";
EGDSBasicRadioGroup.fragment = __Fragment8;

// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
var __Fragment9 = gql34`
  fragment ActivityRadioGroupDialogFragment on ActivityRadioGroupDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    doneButton {
      primary
      action {
        analytics {
          linkName
          referrerId
        }
      }
    }
    heading {
      ...EGDSHeadingFragment
    }
    radioGroup {
      ...EGDSBasicRadioGroupFragment
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${ActivityDialogTrigger.fragment}

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSBasicRadioGroup.fragment}
  ${EGDSDialogToolbar.fragment}
`;
var headingMargin2 = {
  blockend: "two"
};
var ActivityRadioGroupDialog = ({
  className,
  doneClickHandler,
  data,
  isNestedDialog
}) => {
  var _a;
  const {
    heading,
    dialog,
    doneButton: {
      action,
      primary
    },
    radioGroup,
    trigger
  } = data;
  const clickTracker = useClickTracker8();
  const dialogKey = useIdCompatibility6();
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog4(`activity-radio-dialog-${dialogKey}`, nestedDialogKey);
  const [selectedValue, setSelectedValue] = React27.useState((_a = radioGroup.selected) != null ? _a : "");
  const triggerRef = React27.useRef(null);
  const handleOnChange = event => {
    setSelectedValue(event.target.value);
  };
  const handleToolbarAction = React27.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialogActions, dialog.closeAnalytics, clickTracker]);
  const handleDoneOnClick = React27.useCallback(() => {
    if (action == null ? void 0 : action.analytics) {
      clickTracker(action.analytics.referrerId, action.analytics.linkName);
    }
    doneClickHandler(radioGroup.groupName, selectedValue);
    dialogActions.closeDialog();
  }, [doneClickHandler, clickTracker, action == null ? void 0 : action.analytics, dialogActions, radioGroup.groupName, selectedValue]);
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(ActivityDialogTrigger, {
    className,
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React27.createElement(EGDSSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React27.createElement(DialogComponent, null, /* @__PURE__ */React27.createElement(EGDSSheet2, {
    type: "centered",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React27.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: handleToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React27.createElement(EGDSSheetContent2, null, heading && /* @__PURE__ */React27.createElement(EGDSSpacing4, {
    margin: headingMargin2
  }, /* @__PURE__ */React27.createElement(ActivitiesEGDSHeading, {
    size: 6,
    data: heading
  })), /* @__PURE__ */React27.createElement(EGDSBasicRadioGroup, {
    onChange: handleOnChange,
    data: radioGroup
  }), /* @__PURE__ */React27.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React27.createElement(EGDSFloatingFullWidthButton2, {
    size: EGDSButtonSize3.LARGE,
    onClick: handleDoneOnClick
  }, primary)))))));
};
ActivityRadioGroupDialog.displayName = "ActivityRadioGroupDialog";
ActivityRadioGroupDialog.fragment = __Fragment9;

// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
import React37 from "react";
import { EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { gql as gql43 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
import React35, { useRef } from "react";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing8, EGDSSpacingHr } from "@egds/react-core/spacing";
import { gql as gql42 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/utils/utils.ts
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";
function useQueryParams() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return searchParams;
}
function useDeleteParam() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(key => {
    const params = new URLSearchParams(location.search);
    params.delete(key);
    navigate(`${location.pathname}?${params}`, {
      replace: true
    });
  }, [navigate, location]);
}

// ../internal/src/components/activity-reviews-comment/activity-reviews-comment.tsx
import React31 from "react";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { gql as gql38 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-expando/egds-expando-peek.tsx
import React28 from "react";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { gql as gql35 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql35`
  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {
    expandAnalytics {
      linkName
      referrerId
    }
    expandedLabel
    expandedAccessibilityText
    collapsedAccessibilityText
    collapseAnalytics {
      linkName
      referrerId
    }
    collapsedLabel
    expanded
  }
`;
var ActivitiesEGDSExpandoPeek = ({
  lines,
  items,
  className,
  data,
  children
}) => {
  var _a, _b, _c, _d;
  const {
    expanded,
    expandAnalytics,
    expandedLabel,
    collapseAnalytics,
    collapsedLabel,
    expandedAccessibilityText,
    collapsedAccessibilityText
  } = data;
  const clickTracker = useClickTracker9();
  const [isVisible, setIsVisible] = React28.useState(expanded);
  const expandoExpandAnalytics = {
    id: (_a = expandAnalytics == null ? void 0 : expandAnalytics.referrerId) != null ? _a : "",
    description: (_b = expandAnalytics == null ? void 0 : expandAnalytics.linkName) != null ? _b : "",
    callback: React28.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const expandoCollapseAnalytics = {
    id: (_c = collapseAnalytics == null ? void 0 : collapseAnalytics.referrerId) != null ? _c : "",
    description: (_d = collapseAnalytics == null ? void 0 : collapseAnalytics.linkName) != null ? _d : "",
    callback: React28.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const handleClick = React28.useCallback(() => {
    setIsVisible(!isVisible);
  }, [isVisible]);
  return /* @__PURE__ */React28.createElement(EGDSExpandoPeek, {
    expandLabel: collapsedLabel,
    collapseLabel: expandedLabel,
    analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics,
    className,
    lines,
    items,
    isVisible,
    handleClick,
    expandA11yLabel: collapsedAccessibilityText != null ? collapsedAccessibilityText : collapsedLabel,
    collapseA11yLabel: expandedAccessibilityText != null ? expandedAccessibilityText : expandedLabel
  }, children);
};
ActivitiesEGDSExpandoPeek.fragment = fragment12;
ActivitiesEGDSExpandoPeek.displayName = "ActivitiesEGDSExpandoPeek";

// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React29 from "react";
import { EGDSExpandoListItem } from "@egds/react-core/expando";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { gql as gql36 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker10, useEgClickstream } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/utils/eg-activity-clickstream-helper.ts
var buildClickstreamData = clickstreamAnalytics => {
  const {
    clickstreamEvent,
    payload: serverPayload
  } = clickstreamAnalytics;
  const {
    eventName,
    eventType,
    eventVersion,
    eventCategory,
    actionLocation,
    pageName
  } = clickstreamEvent;
  const eventData = {
    event_name: eventName,
    event_version: eventVersion,
    event_type: eventType,
    event_category: eventCategory,
    action_location: actionLocation
  };
  const experience = {
    page_name: pageName
  };
  return __spreadValues({
    clientPayload: {
      event: eventData,
      experience
    }
  }, serverPayload && {
    serverPayload
  });
};

// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
var fragment13 = gql36`
  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {
    collapseAnalytics {
      linkName
      referrerId
    }
    collapsedLabel
    expandAnalytics {
      linkName
      referrerId
    }
    expandedLabel
    expanded
  }
`;
var ActivitiesEGDSExpandoListItem = ({
  children,
  className,
  data,
  titleSize,
  titleTag,
  isIndented,
  selectedEventAnalytics
}) => {
  const {
    expandAnalytics,
    expandedLabel,
    collapseAnalytics,
    collapsedLabel,
    expanded
  } = data;
  const clickTracker = useClickTracker10();
  const trackEgClickStream = useEgClickstream();
  const [isVisible, setIsVisible] = React29.useState(expanded);
  const [label, setLabel] = React29.useState(expanded ? expandedLabel : collapsedLabel);
  let analytics;
  if (collapseAnalytics && expandAnalytics) {
    analytics = {
      id: isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId,
      description: isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName,
      callback: (referrerId, linkName) => {
        clickTracker(referrerId, linkName);
      }
    };
  }
  const onToggle = React29.useCallback(() => {
    if (isVisible) {
      setLabel(collapsedLabel);
    } else {
      setLabel(expandedLabel);
    }
    if (selectedEventAnalytics) {
      trackEgClickStream(buildClickstreamData(selectedEventAnalytics));
    }
    setIsVisible(!isVisible);
  }, [isVisible, collapsedLabel, expandedLabel]);
  return /* @__PURE__ */React29.createElement(EGDSExpandoListItem, {
    analytics,
    className,
    isVisible,
    expandoTitle: /* @__PURE__ */React29.createElement(EGDSHeading2, {
      tag: titleTag,
      size: titleSize
    }, label),
    expandoDescription: children,
    onToggle,
    isIndented
  });
};
ActivitiesEGDSExpandoListItem.fragment = fragment13;
ActivitiesEGDSExpandoListItem.displayName = "ActivitiesEGDSExpandoListItem";

// ../internal/src/components/egds-expando/egds-expando.tsx
import React30 from "react";
import { gql as gql37 } from "@shared-ui/apollo-client-wrapper";
var fragment14 = gql37`
  fragment EGDSExpandoFragment on EGDSExpando {
    ... on EGDSExpandoPeek {
      ...EGDSExpandoPeekFragment
    }
    ... on EGDSExpandoListItem {
      ...EGDSExpandoListItemFragment
    }
  }

  ${ActivitiesEGDSExpandoPeek.fragment}
  ${ActivitiesEGDSExpandoListItem.fragment}
`;
var ActivitiesEGDSExpando = ({
  className,
  expandoListItemTitleSize,
  expandoListItemTitleTag,
  expandoListItemIsIndented,
  expandoPeekLines,
  expandoPeekItems,
  data,
  children
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "EGDSExpandoPeek":
      return /* @__PURE__ */React30.createElement(ActivitiesEGDSExpandoPeek, {
        className,
        data,
        lines: expandoPeekLines,
        items: expandoPeekItems
      }, children);
    case "EGDSExpandoListItem":
      return /* @__PURE__ */React30.createElement(ActivitiesEGDSExpandoListItem, {
        className,
        data,
        titleSize: expandoListItemTitleSize,
        titleTag: expandoListItemTitleTag,
        isIndented: expandoListItemIsIndented
      }, children);
    default:
      return null;
  }
};
ActivitiesEGDSExpando.fragment = fragment14;
ActivitiesEGDSExpando.displayName = "ActivitiesEGDSExpando";

// ../internal/src/components/activity-reviews-comment/activity-reviews-comment.tsx
var __Fragment10 = gql38`
  fragment ActivityReviewsCommentFragment on ActivityReview {
    text
    author
    formattedActivityDate
    overallScoreMessage {
      ...EGDSTextFragment
    }
    formattedSubmissionDate
    reviewedOn
    userLocation
    expando {
      ...EGDSExpandoFragment
    }
  }

  ${ActivitiesEGDSExpando.fragment}
  ${ActivitiesEGDSText.fragment}
`;
var topMargin = {
  blockstart: "two"
};
var ReviewCommentsWrapper = React31.memo(({
  expando,
  text
}) => /* @__PURE__ */React31.createElement(React31.Fragment, null, expando ? /* @__PURE__ */React31.createElement(EGDSSpacing5, {
  margin: topMargin
}, /* @__PURE__ */React31.createElement(ActivitiesEGDSExpando, {
  expandoPeekLines: 4,
  data: expando
}, /* @__PURE__ */React31.createElement(EGDSText7, {
  overflow: "wrap",
  size: 300
}, text))) : /* @__PURE__ */React31.createElement(EGDSSpacing5, {
  margin: topMargin
}, /* @__PURE__ */React31.createElement(EGDSText7, {
  size: 300
}, text))));
ReviewCommentsWrapper.displayName = "ReviewCommentsWrapper";
var ActivityReviewsComment = ({
  className,
  headingSize,
  headingTag,
  data
}) => {
  const {
    author,
    overallScoreMessage,
    reviewedOn,
    formattedSubmissionDate,
    formattedActivityDate,
    userLocation,
    text,
    expando
  } = data;
  return /* @__PURE__ */React31.createElement("div", {
    className
  }, overallScoreMessage && /* @__PURE__ */React31.createElement(ActivitiesEGDSText, {
    data: overallScoreMessage,
    headingSize,
    headingTag
  }), author && /* @__PURE__ */React31.createElement(EGDSSpacing5, {
    margin: topMargin
  }, /* @__PURE__ */React31.createElement(EGDSHeading3, {
    tag: "h3",
    size: 6
  }, author)), reviewedOn && /* @__PURE__ */React31.createElement(EGDSText7, {
    size: 300
  }, reviewedOn), formattedSubmissionDate && /* @__PURE__ */React31.createElement(EGDSText7, {
    size: 300
  }, formattedSubmissionDate), userLocation && /* @__PURE__ */React31.createElement(EGDSText7, {
    size: 300
  }, userLocation), /* @__PURE__ */React31.createElement(ReviewCommentsWrapper, {
    expando,
    text
  }), formattedActivityDate && /* @__PURE__ */React31.createElement(EGDSSpacing5, {
    margin: topMargin
  }, /* @__PURE__ */React31.createElement(EGDSText7, {
    size: 200
  }, formattedActivityDate)));
};
ActivityReviewsComment.displayName = "ActivityReviewsCommentList";
ActivityReviewsComment.fragment = __Fragment10;

// ../internal/src/components/activity-reviews-sort-tab/activity-reviews-sort-tab.tsx
import React32 from "react";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
import { gql as gql39 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
var __Fragment11 = gql39`
  fragment ActivityReviewsSortTabFragment on ActivityTabbedNavigationBar {
    heading
    tabs {
      label
      selected
      clickAction {
        ...ActivityClickActionsFragment
      }
    }
  }

  ${__ActivityClickActionsFragment}
`;
var tabsMargin = {
  block: "two"
};
var ActivityReviewsSortTab = ({
  className,
  data,
  onClick
}) => {
  const {
    heading,
    tabs
  } = data;
  const [activeTab, setActiveTab] = React32.useState(tabs.findIndex(tab => tab.selected));
  const clickTracker = useClickTracker11();
  if (!tabs.length) {
    return null;
  }
  const handleTabChanges = tabIndex => {
    var _a;
    const selectedTab = (_a = tabs[tabIndex]) == null ? void 0 : _a.clickAction;
    const selectedAction = selectedTab ? getClickAction(selectedTab, clickTracker) : null;
    onClick(selectedAction == null ? void 0 : selectedAction.selectedTabAction);
    setActiveTab(tabIndex);
  };
  return /* @__PURE__ */React32.createElement("div", {
    className
  }, heading && /* @__PURE__ */React32.createElement(EGDSHeading4, {
    tag: "h3",
    size: 6
  }, heading), /* @__PURE__ */React32.createElement(EGDSSpacing6, {
    margin: tabsMargin
  }, /* @__PURE__ */React32.createElement(EGDSTabs, {
    onTabSelect: handleTabChanges,
    selectedTab: activeTab,
    tabsType: EGDSTabsType.NATURAL,
    role: "tablist",
    withBorder: true
  }, tabs.map(sortType => {
    var _a, _b;
    return /* @__PURE__ */React32.createElement(EGDSTab, {
      name: sortType.label,
      key: sortType.label,
      targetURI: "#",
      tabLinkAttr: {
        "aria-label": (_b = (_a = sortType.clickAction) == null ? void 0 : _a.accessibilityText) != null ? _b : ""
      }
    });
  }))));
};
ActivityReviewsSortTab.displayName = "ActivityReviewsSortTab";
ActivityReviewsSortTab.fragment = __Fragment11;

// ../internal/src/components/activity-reviews-summary/activity-reviews-summary.tsx
import React33 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { gql as gql40 } from "@shared-ui/apollo-client-wrapper";
var __Fragment12 = gql40`
  fragment ActivityReviewsSummaryFragment on ActivityReviewsSummary {
    averageScore {
      ...EGDSTextFragment
    }
    disclaimer {
      ...ActivityDisclaimerDialogFragment
    }
    sectionRef
    reviewSuperlative {
      size
      ...EGDSStylizedTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
  ${ActivityDisclaimerDialog.fragment}
  ${EGDSStylizedText.fragment}
`;
var disclaimerMargin = {
  inlinestart: "two",
  blockstart: "one"
};
var reviewMargin = {
  blockstart: "one"
};
var ActivityReviewsSummary = ({
  className,
  data,
  dialogIdSuffix,
  headingSize,
  headingTag
}) => {
  const {
    averageScore,
    disclaimer,
    sectionRef,
    reviewSuperlative
  } = data;
  const {
    size: superlativeSize
  } = reviewSuperlative || {};
  const ActivityReviewsRating = () => /* @__PURE__ */React33.createElement("div", {
    className,
    id: sectionRef != null ? sectionRef : void 0
  }, /* @__PURE__ */React33.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React33.createElement(ActivitiesEGDSText, {
    data: averageScore,
    headingSize,
    headingTag,
    tabIndex: -1
  })), disclaimer && /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React33.createElement(EGDSSpacing7, {
    margin: disclaimerMargin
  }, /* @__PURE__ */React33.createElement(ActivityDisclaimerDialog, {
    data: disclaimer,
    dialogIdSuffix
  })))));
  const ActivityHighlightReviewsRating = () => {
    const {
      textSize: averageScoreSize
    } = averageScore;
    return /* @__PURE__ */React33.createElement("div", {
      className,
      id: sectionRef != null ? sectionRef : void 0
    }, /* @__PURE__ */React33.createElement(EGDSLayoutFlex4, {
      wrap: "wrap",
      direction: "column"
    }, /* @__PURE__ */React33.createElement(ActivitiesEGDSText, {
      data: averageScore,
      textSize: Number(averageScoreSize),
      tabIndex: -1
    }), reviewSuperlative && /* @__PURE__ */React33.createElement(EGDSSpacing7, {
      margin: reviewMargin
    }, /* @__PURE__ */React33.createElement(EGDSStylizedText, {
      data: reviewSuperlative,
      size: Number(superlativeSize)
    })), disclaimer && /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React33.createElement(EGDSSpacing7, {
      margin: reviewMargin
    }, /* @__PURE__ */React33.createElement(ActivityDisclaimerDialog, {
      data: disclaimer,
      dialogIdSuffix
    })))));
  };
  return dialogIdSuffix === "ActivityReviews" && averageScore && averageScore.__typename === "EGDSStylizedText" ? ActivityHighlightReviewsRating() : ActivityReviewsRating();
};
ActivityReviewsSummary.displayName = "ActivityReviewsSummary";
ActivityReviewsSummary.fragment = __Fragment12;

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-more-button.tsx
import React34 from "react";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { gql as gql41 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
var __Fragment13 = gql41`
  fragment ActivityReviewsMoreButtonFragment on ActivityReviewsPaginationButton {
    action {
      ...ActivityClickActionsFragment
    }
    button {
      ...EGDSButtonFragment
    }
  }

  ${__ActivityClickActionsFragment}
  ${ActivitiesEGDSButton.fragment}
`;
var ActivityReviewsMoreButton = ({
  data,
  fetchMoreAction
}) => {
  const {
    action,
    button
  } = data;
  const tracker = useClickTracker12();
  const loadMoreReviews = React34.useCallback(() => {
    const selectedAction = getClickAction(action, tracker);
    fetchMoreAction(selectedAction == null ? void 0 : selectedAction.paginatedIndex);
  }, [fetchMoreAction]);
  return /* @__PURE__ */React34.createElement(EGDSSecondaryButton2, {
    "data-stid": "more-reviews-button",
    onClick: loadMoreReviews
  }, button.primary);
};
ActivityReviewsMoreButton.displayName = "ActivityReviewsMoreButton";
ActivityReviewsMoreButton.fragment = __Fragment13;

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
var __Fragment14 = gql42`
  fragment ActivityReviewsDialogContentFragment on ActivityReviewListComponent {
    comments {
      ...ActivityReviewsCommentFragment
    }
    summary {
      ...ActivityReviewsSummaryFragment
    }
    sortTabs {
      ...ActivityReviewsSortTabFragment
    }
    moreButton {
      ...ActivityReviewsMoreButtonFragment
    }
  }

  ${ActivityReviewsComment.fragment}
  ${ActivityReviewsSummary.fragment}
  ${ActivityReviewsSortTab.fragment}
  ${ActivityReviewsMoreButton.fragment}
`;
var reviewPadding = {
  small: {
    inline: "three",
    block: "twelve"
  },
  large: {
    inline: "twelve",
    block: "twelve"
  }
};
var reviewGrid = {
  large: ["1fr", "2fr"]
};
var showMorePadding = {
  blockstart: "six"
};
var ActivityReviewsDialogContent = ({
  data,
  fetchMoreAction,
  handleSortTabClick
}) => {
  const {
    summary,
    comments,
    sortTabs,
    moreButton
  } = data;
  const scrollElementRef = useRef();
  const pageParams = useQueryParams();
  const deleteParam = useDeleteParam();
  const reviewId = pageParams !== void 0 ? pageParams.get("reviewId") : null;
  React35.useEffect(() => {
    var _a;
    if (reviewId) {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      (_a = scrollElementRef.current) == null ? void 0 : _a.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start"
      });
      deleteParam("reviewId");
    }
  }, [reviewId]);
  if (!summary || !comments.length) {
    return null;
  }
  return /* @__PURE__ */React35.createElement(EGDSCard2, null, /* @__PURE__ */React35.createElement(EGDSSpacing8, {
    padding: reviewPadding
  }, /* @__PURE__ */React35.createElement(EGDSLayoutGrid, {
    columns: reviewGrid,
    space: "six"
  }, /* @__PURE__ */React35.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React35.createElement(ActivityReviewsSummary, {
    data: summary,
    dialogIdSuffix: "ActivityReviews",
    headingSize: 5
  })), /* @__PURE__ */React35.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React35.createElement("div", {
    key: "commentsSection"
  }, sortTabs && /* @__PURE__ */React35.createElement(ActivityReviewsSortTab, {
    key: "sortTabs",
    data: sortTabs,
    onClick: handleSortTabClick
  }), comments.map((comment, index) => /* @__PURE__ */React35.createElement("div", {
    key: index,
    ref: index === Number(reviewId) ? scrollElementRef : null
  }, /* @__PURE__ */React35.createElement(ActivityReviewsComment, {
    key: `review-comment-${index}`,
    data: comment
  }), /* @__PURE__ */React35.createElement(EGDSSpacingHr, {
    blockMargin: "six"
  }))), moreButton && /* @__PURE__ */React35.createElement(EGDSSpacing8, {
    padding: showMorePadding
  }, /* @__PURE__ */React35.createElement(EGDSLayoutFlex5, {
    justifyContent: "center"
  }, /* @__PURE__ */React35.createElement(ActivityReviewsMoreButton, {
    fetchMoreAction,
    data: moreButton
  }))))))));
};
ActivityReviewsDialogContent.displayName = "ActivityReviewsDialogContent";
ActivityReviewsDialogContent.fragment = __Fragment14;

// ../internal/src/components/activity-dialog/context/activity-reviews-context.tsx
import React36 from "react";
var ActivityReviewsContext = React36.createContext(void 0);
var useReviewsContentContext = () => {
  const context = React36.useContext(ActivityReviewsContext);
  if (!context) {
    return null;
  }
  return context;
};

// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
var __Fragment15 = gql43`
  fragment ActivityReviewCommentsDialogFragment on ActivityReviewCommentsDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${EGDSDialogToolbar.fragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityReviewCommentsDialog = ({
  reviewsDialogContent,
  onMoreReviewsClickHandler,
  onSortTabClickHandler,
  dialogId,
  openDialogCallBackHandler,
  data: {
    dialog,
    trigger
  }
}) => {
  var _a;
  const {
    closeAnalytics,
    toolbar
  } = dialog;
  const clickTracker = useClickTracker13();
  const dialogIdentifier = `ActivityReviewCommentsDialog-${dialogId}`;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog5(dialogIdentifier, "nestedReviewCommentsDialog");
  const ActivityReviewsContent = (_a = useReviewsContentContext()) == null ? void 0 : _a.ActivityReviewsContent;
  const triggerRef = React37.useRef(null);
  const toolbarAction = () => {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  const dialogTriggerAction = () => {
    dialogActions.openDialog();
    if (openDialogCallBackHandler) {
      openDialogCallBackHandler();
    }
  };
  return /* @__PURE__ */React37.createElement(React37.Fragment, null, /* @__PURE__ */React37.createElement(EGDSLayoutFlex6, null, /* @__PURE__ */React37.createElement(ActivityDialogTrigger, {
    openDialog: dialogTriggerAction,
    data: trigger,
    domRef: triggerRef
  })), /* @__PURE__ */React37.createElement(EGDSSheetTransition5, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React37.createElement(DialogComponent, null, /* @__PURE__ */React37.createElement(EGDSSheet3, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React37.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React37.createElement(EGDSDialogContent2, null, reviewsDialogContent && onMoreReviewsClickHandler && onSortTabClickHandler ? /* @__PURE__ */React37.createElement(ActivityReviewsDialogContent, {
    fetchMoreAction: onMoreReviewsClickHandler,
    handleSortTabClick: onSortTabClickHandler,
    data: reviewsDialogContent
  }) : ActivityReviewsContent && /* @__PURE__ */React37.createElement(ActivityReviewsContent, null))))));
};
ActivityReviewCommentsDialog.displayName = "ActivityReviewCommentsDialog";
ActivityReviewCommentsDialog.fragment = __Fragment15;

// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
import React41 from "react";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { gql as gql48 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility7 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";

// ../internal/src/components/activity-map/activity-map.tsx
import React40 from "react";
import { Map, MapType } from "@egds/react-maps";
import { gql as gql47 } from "@shared-ui/apollo-client-wrapper";

// ../../map/google-maps-sdk-version-provider/src/components/google-maps-sdk-version-provider/google-maps-sdk-version-provider.tsx
import React38, { createContext, useContext, useMemo as useMemo2 } from "react";
var GoogleMapsSdkVersionContext = createContext({
  version: void 0
});
var useGoogleMapsSdkVersion = () => useContext(GoogleMapsSdkVersionContext);
function GoogleMapsSdkVersionProvider({
  version,
  children
}) {
  const memoizedVersion = useMemo2(() => ({
    version
  }), [version]);
  return /* @__PURE__ */React38.createElement(GoogleMapsSdkVersionContext.Provider, {
    value: memoizedVersion
  }, children);
}
GoogleMapsSdkVersionProvider.displayName = "sharedui-GoogleMapsSdkVersionProvider";

// ../internal/src/components/activity-map/__private/utils/get-qualifiers.ts
import { MapQualifier } from "@egds/react-maps";
var egMapsIconTypeMapper = {
  hotel: MapQualifier.HOTEL,
  people: MapQualifier.PEOPLE,
  activity: MapQualifier.ACTIVITY,
  focal: MapQualifier.FOCAL
};
var getQualifiers = qualifiers => qualifiers.map(qualifier => egMapsIconTypeMapper[qualifier] || egMapsIconTypeMapper.hotel);

// ../internal/src/components/activity-map/__private/utils/get-feature-object.ts
var getFeatureObject = (marker, index) => {
  const {
    markerStatus,
    markerIconType,
    markerPosition,
    placeCard,
    markerType,
    text
  } = marker;
  const commonFields = {
    id: index,
    qualifiers: getQualifiers(markerIconType),
    lat: markerPosition.latitude,
    lng: markerPosition.longitude,
    thumbnail: placeCard == null ? void 0 : placeCard.image
  };
  switch (markerType) {
    case "property":
    // property is deprecated and will fallback to default when returned from experience layer
    case "product":
      return __spreadValues({
        type: "product",
        status: markerStatus.toLowerCase(),
        price: text
      }, commonFields);
    case "place":
      return __spreadValues({
        type: "place",
        status: "unknown",
        text
      }, commonFields);
    default:
      return __spreadValues({
        type: "place",
        status: "unknown",
        text
      }, commonFields);
  }
};

// ../internal/src/components/activity-map/__private/map-marker.ts
import { gql as gql45 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/activity-map/__private/activity-map-place-card.tsx
import React39 from "react";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet4, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { gql as gql44 } from "@shared-ui/apollo-client-wrapper";
var fragment15 = gql44`
  fragment ActivityMapPlaceCardFragment on ActivityMapPlaceCard {
    image {
      description
      url
    }
    primary {
      ...EGDSTextFragment
    }
    secondaries {
      ...EGDSTextFragment
    }
    tag {
      ...EGDSTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
`;
var gridColumnsWithImage = ["1fr", "3fr"];
var gridColumns = ["1fr"];
var ActivityMapPlaceCard = ({
  className,
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    image,
    primary,
    secondaries,
    tag
  } = data;
  return /* @__PURE__ */React39.createElement(EGDSSheetTransition6, {
    isVisible: true
  }, /* @__PURE__ */React39.createElement(EGDSSheet4, {
    className,
    isVisible: true,
    triggerRef: null
  }, /* @__PURE__ */React39.createElement(EGDSLayoutGrid2, {
    columns: image ? gridColumnsWithImage : gridColumns
  }, image && /* @__PURE__ */React39.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React39.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R16_9
  }, /* @__PURE__ */React39.createElement(EGDSImage2, {
    alt: image.description,
    src: image.url,
    placeholderImage: true
  }))), /* @__PURE__ */React39.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React39.createElement(EGDSSpacing9, {
    padding: "three"
  }, /* @__PURE__ */React39.createElement(EGDSLayoutFlex7, {
    direction: "column",
    space: "one"
  }, tag && /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React39.createElement(ActivitiesEGDSText, {
    data: tag
  })), primary && /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React39.createElement(ActivitiesEGDSText, {
    data: primary
  })), secondaries == null ? void 0 : secondaries.map((secondary, key) => /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem5, {
    key: `map-place-card-secondaries${key}`
  }, /* @__PURE__ */React39.createElement(ActivitiesEGDSText, {
    data: secondary
  })))))))));
};
ActivityMapPlaceCard.fragment = fragment15;
ActivityMapPlaceCard.displayName = "ActivityMapPlaceCard";

// ../internal/src/components/activity-map/__private/map-marker.ts
var __MapMarkersFragment = gql45`
  fragment MapMarkersFragment on ActivityMapMarker {
    markerType
    markerIconType
    markerStatus
    markerPosition {
      latitude
      longitude
    }
    text
    placeCard {
      ...ActivityMapPlaceCardFragment
    }
  }

  ${ActivityMapPlaceCard.fragment}
`;

// ../internal/src/components/activity-map/egds-dynamic-map-config.ts
import { gql as gql46 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDynamicMapConfigFragment = gql46`
  fragment EGDSDynamicMapConfigFragment on EGDSDynamicMapConfig {
    accessToken
    egdsMapProvider
  }
`;

// ../internal/src/components/activity-map/activity-map.tsx
var fragment16 = gql47`
  fragment ActivityMapFragment on ActivityMap {
    __typename
    egMap {
      center {
        latitude
        longitude
      }
      config {
        ...EGDSDynamicMapConfigFragment
      }
    }
    markers {
      ...MapMarkersFragment
    }
  }

  ${__EGDSDynamicMapConfigFragment}
  ${__MapMarkersFragment}
`;
var ActivityMap = ({
  data,
  dynamicMapSize
}) => {
  var _a;
  const {
    egMap,
    markers
  } = data;
  const {
    config
  } = egMap;
  const [, setSelectedMarker] = React40.useState(null);
  const [placeCard, setPlaceCard] = React40.useState(null);
  const accessToken = config.__typename === "EGDSDynamicMapConfig" ? config.accessToken : "";
  const mapFeatures = markers.map((marker, index) => getFeatureObject(marker, index));
  const coordinates = mapFeatures.filter(f => f.lat !== void 0 && f.lng !== void 0).map(feature => ({
    lat: feature.lat || 0,
    lng: feature.lng || 0
  }));
  const onMarkerSelectionChanged = React40.useCallback(event => {
    var _a2;
    const {
      action,
      feature
    } = event;
    switch (action) {
      case "clearSelection":
        setSelectedMarker(null);
        setPlaceCard(null);
        break;
      case "select":
        setSelectedMarker(feature);
        setPlaceCard((_a2 = markers[feature.id]) == null ? void 0 : _a2.placeCard);
        break;
      default:
        break;
    }
  }, [markers]);
  const beforeInit = React40.useCallback(map => {
    map.addSelectionChangeListener(onMarkerSelectionChanged, "selectionChanged");
  }, [onMarkerSelectionChanged]);
  const initialViewport = {
    useBoundsComputation: true,
    coordinates: coordinates.length > 0 ? coordinates : void 0
  };
  const mapConfig = React40.useMemo(() => ({
    markers: {
      product: {
        markerType: {
          available: "pin"
        }
      }
    }
  }), []);
  const googleMapsSdkVersion = (_a = useGoogleMapsSdkVersion()) == null ? void 0 : _a.version;
  return /* @__PURE__ */React40.createElement(Map, {
    accessToken,
    mapType: MapType.GOOGLE,
    mapTypeVersion: googleMapsSdkVersion,
    features: mapFeatures,
    height: dynamicMapSize,
    initialViewport,
    beforeInit,
    mapConfig
  }, placeCard && /* @__PURE__ */React40.createElement(ActivityMapPlaceCard, {
    data: placeCard
  }));
};
ActivityMap.fragment = fragment16;
ActivityMap.displayName = "ActivityMap";

// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
var __Fragment16 = gql48`
  fragment ActivityLocationMapDialogFragment on ActivityLocationMapDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    dynamicMap {
      ...ActivityMapFragment
    }
  }

  ${EGDSDialogToolbar.fragment}

  ${ActivityMap.fragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityLocationMapDialog = ({
  data: {
    dialog,
    trigger,
    dynamicMap
  }
}) => {
  const {
    closeAnalytics,
    toolbar
  } = dialog;
  const clickTracker = useClickTracker14();
  const dialogKey = useIdCompatibility7();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog6(`activity-map-${dialogKey}`, "nestedActivityMapDialog");
  const triggerRef = React41.useRef(null);
  const toolbarAction = () => {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, /* @__PURE__ */React41.createElement(ActivityDialogTrigger, {
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React41.createElement(EGDSSheetTransition7, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React41.createElement(DialogComponent, null, /* @__PURE__ */React41.createElement(EGDSSheet5, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React41.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React41.createElement(ActivityMap, {
    data: dynamicMap
  })))));
};
ActivityLocationMapDialog.displayName = "ActivityLocationMapDialog";
ActivityLocationMapDialog.fragment = __Fragment16;

// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-action-dialog.tsx
import React42 from "react";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent3, EGDSDialogFooter as EGDSDialogFooter2 } from "@egds/react-core/dialog";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSHeading as EGDSHeading5, EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { gql as gql49 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
var fragment17 = gql49`
  fragment SignInActivityActionDialogFragment on EGDSActionDialog {
    closeAnalytics {
      referrerId
      linkName
    }
    footer {
      ... on EGDSStackedDialogFooter {
        buttons {
          ... on EGDSOverlayButton {
            __typename
          }
        }
      }
      ... on EGDSInlineDialogFooter {
        buttons {
          ... on UIPrimaryButton {
            accessibility
            primary
            disabled
            action {
              ... on UILinkAction {
                resource {
                  value
                }
                analytics {
                  linkName
                  referrerId
                }
              }
            }
          }
          ... on UITertiaryButton {
            accessibility
            primary
            action {
              ... on UILinkAction {
                resource {
                  value
                }
              }
            }
            disabled
          }
        }
      }
    }
  }
`;
var SignInActivityActionDialog = ({
  data,
  actionsCallback,
  closeDialog,
  content,
  title,
  graphic
}) => {
  const clickstreamAnalytics = useClickTracker15();
  const {
    footer: {
      buttons
    }
  } = data;
  const triggerRef = React42.createRef();
  const handleCloseButtonClick = () => {
    closeDialog();
  };
  const handleActionButtonClick = (url, analytics) => {
    window.location.replace(url);
    clickstreamAnalytics(analytics.referrerId, analytics.linkName);
  };
  const [buttonOne, buttonTwo, buttonThree] = buttons.map(currentButton => {
    if (currentButton.__typename === "UIPrimaryButton") {
      const {
        primary: primary2
      } = currentButton;
      const primarybtn = {
        text: primary2,
        type: "primary",
        onClick: () => {
          var _a;
          return ((_a = currentButton.action) == null ? void 0 : _a.__typename) === "UILinkAction" ? handleActionButtonClick(currentButton.action.resource.value, currentButton.action.analytics) : handleCloseButtonClick();
        }
      };
      return primarybtn;
    }
    const {
      primary
    } = currentButton;
    return {
      text: primary,
      type: "tertiary",
      onClick: () => handleCloseButtonClick()
    };
  });
  return /* @__PURE__ */React42.createElement(EGDSDialog2, {
    dialogShow: true,
    returnFocusOnClose: true
  }, /* @__PURE__ */React42.createElement(EGDSDialogContent3, null, /* @__PURE__ */React42.createElement(EGDSLayoutGrid3, {
    columns: ["0.8fr", "8fr"],
    space: "one",
    justifyContent: "start"
  }, /* @__PURE__ */React42.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React42.createElement("div", null, graphic && /* @__PURE__ */React42.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React42.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React42.createElement("div", null, /* @__PURE__ */React42.createElement(EGDSHeading5, {
    size: 5
  }, title), /* @__PURE__ */React42.createElement(EGDSParagraph2, {
    key: "dialogParagraph",
    size: 2
  }, content)))), /* @__PURE__ */React42.createElement(EGDSDialogFooter2, {
    stacked: false,
    buttonOne,
    buttonTwo
  })));
};
SignInActivityActionDialog.fragment = fragment17;
SignInActivityActionDialog.displayName = "SignInActivityActionDialog";

// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-dialog.tsx
import React43 from "react";
import { EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { gql as gql50 } from "@shared-ui/apollo-client-wrapper";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
var fragment18 = gql50`
  fragment SignInActivityDialogFragment on EGDSDialog {
    ...SignInActivityActionDialogFragment
  }
  ${SignInActivityActionDialog.fragment}
`;
var SignInActivityDialog = ({
  data,
  title,
  dialogId,
  dialogContent,
  handleActionsCallback,
  graphic
}) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog7(dialogId);
  const closeDialog = () => {
    dialogActions.closeDialog();
  };
  if (!dialogContent) {
    return null;
  }
  return /* @__PURE__ */React43.createElement("div", {
    "data-stid": dialogId
  }, /* @__PURE__ */React43.createElement(EGDSSheetTransition8, {
    isVisible: true
  }, /* @__PURE__ */React43.createElement(DialogComponent, null, /* @__PURE__ */React43.createElement(SignInActivityActionDialog, {
    data,
    content: dialogContent,
    closeDialog,
    title,
    actionsCallback: handleActionsCallback,
    graphic
  }))));
};
SignInActivityDialog.fragment = fragment18;
SignInActivityDialog.displayName = "SignInActivityDialog";

// ../internal/src/components/activity-price-display/activity-price-display.tsx
import React45 from "react";
import { EGDSDialog as EGDSDialog3, EGDSDialogContent as EGDSDialogContent4, EGDSDialogFooter as EGDSDialogFooter3 } from "@egds/react-core/dialog";
import { EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { gql as gql52 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility8 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";

// ../internal/src/components/egds-price-lockup/egds-price-lockup.tsx
import React44 from "react";
import { EGDSPriceLockup } from "@egds/react-core/price-lockup";
import { gql as gql51 } from "@shared-ui/apollo-client-wrapper";
var __Fragment17 = gql51`
  fragment EGDSPriceLockupFragment on EGDSPriceLockup {
    isPointsFirst
    accessibilityPrice
    accessibilityStrikeThroughDialogTrigger
    leadingCaption
    lockupFormattedPoints
    lockupPrice
    priceSubtextFirst
    priceSubtextStandard
    strikeThroughPrice
  }
`;
var ActivitiesEGDSPriceLockup = ({
  className,
  align,
  openStrikeThroughDialog,
  data,
  isStrikeThroughFirst,
  triggerRef
}) => {
  const {
    accessibilityPrice,
    accessibilityStrikeThroughDialogTrigger,
    leadingCaption,
    lockupFormattedPoints,
    lockupPrice,
    priceSubtextFirst,
    priceSubtextStandard,
    strikeThroughPrice,
    isPointsFirst
  } = data;
  return /* @__PURE__ */React44.createElement(EGDSPriceLockup, {
    align,
    isPointsFirst: isPointsFirst != null ? isPointsFirst : false,
    a11yPrice: accessibilityPrice,
    className,
    lockupFormattedPoints: lockupFormattedPoints != null ? lockupFormattedPoints : void 0,
    lockupPrice: lockupPrice != null ? lockupPrice : void 0,
    leadingCaption: leadingCaption != null ? leadingCaption : void 0,
    priceSubtextFirst: [...(priceSubtextFirst || [])],
    priceSubtextStandard: [...(priceSubtextStandard || [])],
    strikeThroughPrice: strikeThroughPrice != null ? strikeThroughPrice : void 0,
    a11yStrikeThroughDialogTrigger: accessibilityStrikeThroughDialogTrigger != null ? accessibilityStrikeThroughDialogTrigger : void 0,
    strikeThroughTrigger: !!openStrikeThroughDialog && /* @__PURE__ */React44.createElement("button", {
      ref: triggerRef,
      onClick: openStrikeThroughDialog,
      type: "button",
      className: "uitk-more-info-trigger"
    }),
    isStrikeThroughFirst
  });
};
ActivitiesEGDSPriceLockup.displayName = "ActivitiesEGDSPriceLockup";
ActivitiesEGDSPriceLockup.fragment = __Fragment17;

// ../internal/src/components/activity-price-display/__private/price-display-align-mapper.ts
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign2 } from "@egds/react-core/price-lockup";
var priceDisplayAlignMapper = {
  [EGDSPriceLockupAlign2.LEFT]: "left",
  [EGDSPriceLockupAlign2.RIGHT]: "right"
};

// ../internal/src/components/activity-price-display/activity-price-display.tsx
var __Fragment18 = gql52`
  fragment ActivityPriceDisplayFragment on ActivityPriceDisplay {
    header {
      ...EGDSTextFragment
    }
    footer {
      ...EGDSTextFragment
    }
    priceLockup {
      ...EGDSPriceLockupFragment
    }
    disclaimer {
      contents {
        ...EGDSTextFragment
      }
      dialog {
        closeAnalytics {
          linkName
          referrerId
        }
        footer {
          buttons {
            primary
            accessibility
            disabled
          }
        }
      }
      trigger {
        analytics {
          linkName
          referrerId
        }
      }
    }
  }

  ${ActivitiesEGDSText.fragment}
  ${ActivitiesEGDSPriceLockup.fragment}
`;
var headerMargin = {
  blockstart: "one"
};
var priceLockupMargin = {
  blockstart: "one"
};
var footerMargin = {
  blockstart: "one"
};
var ActivityPriceDisplay = ({
  className,
  data,
  align,
  isStrikeThroughFirst
}) => {
  var _a, _b;
  const {
    priceLockup,
    header,
    footer,
    disclaimer
  } = data;
  const clickTracker = useClickTracker16();
  const dialogKey = useIdCompatibility8();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog8(`activity-price-disclaimer-${dialogKey}`, "priceDisclaimeriDialog");
  const openPriceDisclaimerDialog = () => {
    dialogActions.openDialog();
    if ((disclaimer == null ? void 0 : disclaimer.trigger.__typename) === "ActivityGraphicDialogTrigger") {
      clickTracker(disclaimer.trigger.analytics.referrerId, disclaimer.trigger.analytics.linkName);
    }
  };
  const closePriceDisclaimerDialog = () => {
    dialogActions.closeDialog();
    if (disclaimer == null ? void 0 : disclaimer.dialog.closeAnalytics) {
      clickTracker(disclaimer.dialog.closeAnalytics.referrerId, disclaimer.dialog.closeAnalytics.linkName);
    }
  };
  const triggerRef = React45.useRef(null);
  return priceLockup && /* @__PURE__ */React45.createElement("section", {
    className
  }, (header == null ? void 0 : header.length) && header.map((headerText, index) => /* @__PURE__ */React45.createElement(EGDSSpacing10, {
    key: `activity-price-info-header-${index}`,
    margin: headerMargin
  }, /* @__PURE__ */React45.createElement(ActivitiesEGDSText, {
    textAlign: align && priceDisplayAlignMapper[align],
    textSize: 200,
    data: headerText
  }))), /* @__PURE__ */React45.createElement(EGDSSpacing10, {
    margin: priceLockupMargin
  }, /* @__PURE__ */React45.createElement(ActivitiesEGDSPriceLockup, {
    openStrikeThroughDialog: disclaimer ? openPriceDisclaimerDialog : void 0,
    align,
    data: priceLockup,
    isStrikeThroughFirst,
    triggerRef
  })), (footer == null ? void 0 : footer.length) && footer.map((footerText, index) => /* @__PURE__ */React45.createElement(EGDSSpacing10, {
    key: `activity-price-info-header-${index}`,
    margin: footerMargin
  }, /* @__PURE__ */React45.createElement(ActivitiesEGDSText, {
    textAlign: align && priceDisplayAlignMapper[align],
    textSize: 200,
    data: footerText
  }))), disclaimer && /* @__PURE__ */React45.createElement(EGDSSheetTransition9, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React45.createElement(DialogComponent, null, /* @__PURE__ */React45.createElement(EGDSDialog3, {
    dialogShow: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React45.createElement(EGDSDialogContent4, null, disclaimer.contents.map((content, index) => /* @__PURE__ */React45.createElement(ActivitiesEGDSText, {
    key: `activity-price-disclaimer-contents-${index}`,
    data: content
  })), /* @__PURE__ */React45.createElement(EGDSDialogFooter3, {
    buttonOne: {
      onClick: closePriceDisclaimerDialog,
      text: (_b = (_a = disclaimer.dialog.footer.buttons[0]) == null ? void 0 : _a.primary) != null ? _b : "",
      type: "tertiary"
    }
  }))))));
};
ActivityPriceDisplay.displayName = "ActivityPriceDisplay";
ActivityPriceDisplay.fragment = __Fragment18;

// ../internal/src/components/egds-date-range/egds-date-range.tsx
import React47 from "react";
import { gql as gql55 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-date-range/egds-basic-date-range.tsx
import React46 from "react";
import { EGDSDateRange } from "@egds/react-core/date-range";
import { gql as gql54 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";

// ../internal/src/components/egds-date-range/__private/__fragments/egds-date-range-result.ts
import { gql as gql53 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDateRangeResultFragment = gql53`
  fragment EGDSDateRangeResultFragment on EGDSDateRangeResult {
    accessibility
    analytics {
      linkName
      referrerId
    }
    date {
      ...DateFragment
    }
    label
    theme
  }

  ${__DateFragment}
`;

// ../internal/src/components/egds-date-range/__private/text-theme-mapper.ts
var textThemeMapper2 = {
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["LINK" /* LINK */]: "link"
};

// ../internal/src/components/egds-date-range/egds-basic-date-range.tsx
var __Fragment19 = gql54`
  fragment EGDSBasicDateRangeFragment on EGDSBasicDateRange {
    loadingMessage
    results {
      ...EGDSDateRangeResultFragment
    }
  }

  ${__EGDSDateRangeResultFragment}
`;
var EGDSBasicDateRange = ({
  className,
  loading,
  onClick,
  data,
  selectedDate
}) => {
  const {
    formatDate
  } = useLocalization2();
  const clickTracker = useClickTracker17();
  const {
    loadingMessage,
    results
  } = data;
  const [selectedDateState, setSelectedDateState] = React46.useState(selectedDate);
  React46.useEffect(() => {
    setSelectedDateState(selectedDate);
  }, [selectedDate]);
  const handleOnClickCallback = React46.useCallback(date => {
    setSelectedDateState(date);
    onClick(date);
  }, [onClick]);
  const getDateRangeResults = React46.useMemo(() => {
    return results.map(result => {
      const {
        accessibility,
        analytics,
        date,
        label,
        theme
      } = result;
      const resultDate = new Date(date.year, date.month - 1, date.day);
      const getDateText = formatDate(resultDate, {
        skeleton: "MMMEd"
      });
      const getTextTheme = theme ? textThemeMapper2[theme] : void 0;
      const isSelected = selectedDateState ? new Date(selectedDateState.year, selectedDateState.month - 1, selectedDateState.day).toDateString() === resultDate.toDateString() : false;
      const analyticsConfig = analytics ? {
        description: analytics.linkName,
        id: analytics.referrerId,
        callback: (referrerId, linkName) => {
          clickTracker(referrerId, linkName);
        }
      } : void 0;
      return {
        accessibilityMessage: accessibility != null ? accessibility : void 0,
        analytics: analyticsConfig,
        dateText: getDateText,
        onClickCallback: () => handleOnClickCallback(date),
        selected: isSelected,
        text: label,
        textTheme: getTextTheme
      };
    });
  }, [clickTracker, formatDate, handleOnClickCallback, results, selectedDateState]);
  return /* @__PURE__ */React46.createElement("div", {
    className
  }, /* @__PURE__ */React46.createElement(EGDSDateRange, {
    loading,
    loadingMessage: loadingMessage != null ? loadingMessage : void 0,
    results: getDateRangeResults
  }));
};
EGDSBasicDateRange.fragment = __Fragment19;
EGDSBasicDateRange.displayName = "EGDSBasicDateRange";

// ../internal/src/components/egds-date-range/egds-date-range.tsx
var __Fragment20 = gql55`
  fragment EGDSDateRangeFragment on EGDSDateRange {
    ... on EGDSBasicDateRange {
      ...EGDSBasicDateRangeFragment
    }
  }

  ${EGDSBasicDateRange.fragment}
`;
var ActivitiesEGDSDateRange = ({
  className,
  loading,
  onClick,
  data,
  selectedDate
}) => {
  switch (data.__typename) {
    case "EGDSBasicDateRange":
      return /* @__PURE__ */React47.createElement(EGDSBasicDateRange, {
        className,
        loading,
        onClick,
        data,
        selectedDate
      });
    default:
      return null;
  }
};
ActivitiesEGDSDateRange.fragment = __Fragment20;
ActivitiesEGDSDateRange.displayName = "ActivitiesEGDSDateRange";

// src/components/offers/__private/__fragments/offers-summary/offers-summary.tsx
import { gql as gql92 } from "@shared-ui/apollo-client-wrapper";

// src/components/offers/__private/__fragments/offers-summary/offers-list-dialog/offers-list-dialog.tsx
import React83 from "react";
import { EGDSDialogContent as EGDSDialogContent5 } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet6, EGDSSheetTransition as EGDSSheetTransition10 } from "@egds/react-core/sheet";
import { gql as gql91 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility10 } from "@shared-ui/core-react-compatibility";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";

// src/components/member-sign-in-dialog/member-sign-in-dialog.tsx
import React48 from "react";
import { gql as gql56 } from "@shared-ui/apollo-client-wrapper";
var fragment19 = gql56`
  fragment ActivityMemberSignInFragment on MemberSignInDialog {
    actionDialog {
      ...SignInActivityActionDialogFragment
    }
    dialogContent
    title
    graphic {
      ...EGDSGraphicFragment
    }
  }
  ${SignInActivityActionDialog.fragment}
  ${EGDSGraphic.fragment}
`;
var ActivitySignInDialog = ({
  data,
  dialogId
}) => {
  const {
    dialogContent,
    title,
    graphic
  } = data;
  const {
    actionDialog
  } = data;
  return /* @__PURE__ */React48.createElement(SignInActivityDialog, {
    dialogContent,
    data: actionDialog,
    dialogId,
    title,
    graphic
  });
};
ActivitySignInDialog.fragment = fragment19;
ActivitySignInDialog.displayName = "ActivitySignInDialog";

// src/components/offers/__private/__fragments/offers-list/offers-list.tsx
import React82, { useRef as useRef2 } from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid7, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing24, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10 } from "@egds/react-core/text";

// ../internal/src/components/activity-toggle/activity-toggle.tsx
import React49 from "react";
import { EGDSSwitch } from "@egds/react-core/switch";
import { gql as gql57 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { useIdCompatibility as useIdCompatibility9 } from "@shared-ui/core-react-compatibility";
var __Fragment21 = gql57`
  fragment ActivityToggleFragment on ActivityToggle {
    checked
    checkedAnalytics {
      linkName
      referrerId
    }
    checkedLabel
    enabled
    uncheckedAnalytics {
      linkName
      referrerId
    }
    uncheckedLabel
  }
`;
var ActivityToggle = ({
  className,
  onChange,
  switchPosition,
  data
}) => {
  const {
    checked,
    checkedLabel,
    checkedAnalytics,
    enabled,
    uncheckedLabel,
    uncheckedAnalytics
  } = data;
  const clickTracker = useClickTracker18();
  const [isChecked, setIsChecked] = React49.useState(checked);
  const switchKey = useIdCompatibility9();
  const handleOnChange = React49.useCallback(() => {
    if (checkedAnalytics && !isChecked) {
      clickTracker(checkedAnalytics.referrerId, checkedAnalytics.linkName);
    }
    if (uncheckedAnalytics && isChecked) {
      clickTracker(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
    }
    setIsChecked(!isChecked);
    onChange(!isChecked);
  }, [checkedAnalytics, uncheckedAnalytics, isChecked, onChange]);
  return /* @__PURE__ */React49.createElement(EGDSSwitch, {
    id: `ActivityToggle-${switchKey}`,
    className,
    switchPosition,
    checked: isChecked,
    disabled: !enabled,
    onChange: handleOnChange,
    label: isChecked ? checkedLabel : uncheckedLabel
  });
};
ActivityToggle.fragment = __Fragment21;
ActivityToggle.displayName = "ActivityToggle";

// src/components/offers/__private/__fragments/offers-list/offers-list.tsx
import { gql as gql90, useLazyQuery as useLazyQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { LineOfBusinessDomain, OneKeyBanner, PageLocation } from "@shared-ui/retail-loyalty-one-key-banner";
import { ProductType } from "@shared-ui/retail-product-type-providers";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";

// src/components/offers/__private/__fragments/offer-details-card/offer-details-card.tsx
import React76 from "react";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard3, EGDSCardPlaceholder } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem6, Repeat } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing21, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7, EGDSParagraph as EGDSParagraph3 } from "@egds/react-core/text";
import { EGDSUnformattedHtml as EGDSUnformattedHtml2, EGDSUnformattedHtmlReplaceDefaults } from "@egds/react-core/unformatted-html";

// ../internal/src/components/activity-card/activity-card-content/activity-card-text-content.tsx
import React50 from "react";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { gql as gql58 } from "@shared-ui/apollo-client-wrapper";
var __Fragment22 = gql58`
  fragment ActivityCardTextContentFragment on ActivityCardTextContent {
    expando {
      ...EGDSExpandoFragment
    }
    heading {
      ...EGDSTextFragment
    }
    items {
      ...EGDSTextFragment
    }
  }

  ${ActivitiesEGDSExpando.fragment}
  ${ActivitiesEGDSText.fragment}
`;
var topMargin2 = {
  blockstart: "two"
};
var ActivityCardTextContent = ({
  className,
  headingSize,
  textSize,
  data
}) => {
  const {
    heading,
    items,
    expando
  } = data;
  return items.length ? /* @__PURE__ */React50.createElement("div", {
    className
  }, heading && /* @__PURE__ */React50.createElement(ActivitiesEGDSText, {
    headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React50.createElement(EGDSSpacing11, {
    margin: topMargin2
  }, /* @__PURE__ */React50.createElement(ActivitiesEGDSExpando, {
    expandoPeekLines: 4,
    data: expando
  }, items.map((item, index) => /* @__PURE__ */React50.createElement(ActivitiesEGDSText, {
    key: `activity-card-text-content-item-${index}`,
    textSize,
    data: item
  })))) : items.map((item, index) => /* @__PURE__ */React50.createElement(EGDSSpacing11, {
    key: `activity-card-text-content-item-${index}`,
    margin: topMargin2
  }, /* @__PURE__ */React50.createElement(ActivitiesEGDSText, {
    textSize,
    data: item
  })))) : null;
};
ActivityCardTextContent.displayName = "ActivityCardTextContent";
ActivityCardTextContent.fragment = __Fragment22;

// ../internal/src/components/activity-card/activity-card-content/activity-card-heading-content.tsx
import React51 from "react";
import { gql as gql59 } from "@shared-ui/apollo-client-wrapper";
var __Fragment23 = gql59`
  fragment ActivityCardHeadingContentFragment on ActivityCardHeadingContent {
    heading {
      ...EGDSTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
`;
var ActivityCardHeadingContent = ({
  className,
  headingSize,
  data
}) => {
  const {
    heading
  } = data;
  return heading && /* @__PURE__ */React51.createElement(ActivitiesEGDSText, {
    className,
    headingSize,
    data: heading
  });
};
ActivityCardHeadingContent.displayName = "ActivityCardHeadingContent";
ActivityCardHeadingContent.fragment = __Fragment23;

// ../internal/src/components/activity-card/activity-card-content/activity-card-text-list-content.tsx
import React63 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { gql as gql71 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-text-list.tsx
import React61 from "react";
import { gql as gql69 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-bulleted-list.tsx
import React58 from "react";
import { withEGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList2 } from "@egds/react-core/list";
import { gql as gql66 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/__private/text-list-size.ts
var textListSizeMapper = {
  ["LIST_1" /* LIST_1 */]: 1,
  ["LIST_2" /* LIST_2 */]: 2,
  ["LIST_3" /* LIST_3 */]: 3
};

// ../internal/src/components/egds-list/egds-text-list-item.tsx
import React57 from "react";
import { gql as gql65 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/earn-message-container-list-item.tsx
import React52 from "react";
import { EGDSListItem } from "@egds/react-core/list";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { gql as gql60 } from "@shared-ui/apollo-client-wrapper";
var fragment20 = gql60`
  fragment EarnMessageContainerListItemFragment on EarnMessageContainerListItem {
    graphic {
      ...EGDSGraphicFragment
    }
    stylizedText {
      ...EGDSSpannableTextFragment
    }
    style
    text
  }

  ${EGDSGraphic.fragment}
  ${EGDSSpannableText.fragment}
`;
var EarnMessageContainerListItem = ({
  className,
  textSize,
  inline,
  data
}) => {
  const themeProps = data.style ? EGDSTextThemeMapper[data.style] : void 0;
  return /* @__PURE__ */React52.createElement(EGDSListItem, null, /* @__PURE__ */React52.createElement(EGDSGraphic, {
    data: data.graphic
  }), /* @__PURE__ */React52.createElement("div", {
    "data-stid": "loyalty-earn-message"
  }, data.stylizedText && /* @__PURE__ */React52.createElement(ActivitiesEGDSText, {
    className,
    data: data.stylizedText,
    textSize,
    theme: themeProps,
    inline
  }), !data.stylizedText && /* @__PURE__ */React52.createElement(EGDSText8, {
    className,
    size: textSize,
    theme: themeProps
  }, "$", data.text)));
};
EarnMessageContainerListItem.fragment = fragment20;
EarnMessageContainerListItem.displayName = "EarnMessageContainerListItem";

// ../internal/src/components/egds-list/egds-text-icon-link-list-item.tsx
import React53 from "react";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
import { gql as gql61 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
var fragment21 = gql61`
  fragment EGDSTextIconLinkListItemFragment on EGDSTextIconLinkListItem {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    icon {
      ...EGDSIconFragment
    }
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var EGDSTextIconLinkListItem = ({
  data
}) => {
  const {
    text,
    icon,
    action: {
      accessibility,
      analytics,
      resource,
      target
    }
  } = data;
  const clickTracker = useClickTracker19();
  const onClick = React53.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React53.createElement(EGDSListItem2, null, /* @__PURE__ */React53.createElement(ActivitiesEGDSIcon, {
    data: icon
  }), /* @__PURE__ */React53.createElement(EGDSLink4, {
    onClickCapture: onClick
  }, /* @__PURE__ */React53.createElement("a", {
    target: UILinkTargetMap[target],
    href: resource.value
  }, text, accessibility && /* @__PURE__ */React53.createElement(EGDSText9, {
    className: "is-visually-hidden"
  }, accessibility))));
};
EGDSTextIconLinkListItem.fragment = fragment21;
EGDSTextIconLinkListItem.displayName = "EGDSTextIconLinkListItem";

// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
import React55 from "react";
import { EGDSList, EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
import { gql as gql63 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
import React54 from "react";
import { EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
import { gql as gql62 } from "@shared-ui/apollo-client-wrapper";
var fragment22 = gql62`
  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {
    text
  }
`;
var EGDSTextStandardListItem = ({
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React54.createElement(EGDSListItem3, null, text);
};
EGDSTextStandardListItem.fragment = fragment22;
EGDSTextStandardListItem.displayName = "EGDSTextStandardListItem";

// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
var fragment23 = gql63`
  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {
    icon {
      ...EGDSIconFragment
    }
    text
    nestedList {
      listItems {
        ... on EGDSTextStandardListItem {
          text
        }
      }
    }
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var EGDSTextIconListItem = ({
  data,
  nestedListBullet
}) => {
  const {
    text,
    icon,
    nestedList
  } = data;
  return /* @__PURE__ */React55.createElement(EGDSListItem4, null, /* @__PURE__ */React55.createElement(ActivitiesEGDSIcon, {
    data: icon
  }), text, nestedList && /* @__PURE__ */React55.createElement(EGDSList, {
    spacing: !!text,
    bullet: nestedListBullet
  }, nestedList.listItems.map((listItem, index) => {
    if (listItem.__typename === "EGDSTextStandardListItem") {
      return /* @__PURE__ */React55.createElement(EGDSTextStandardListItem, {
        data: listItem,
        key: `egds-text-standard-list-item-${index}`
      });
    }
    return null;
  })));
};
EGDSTextIconListItem.fragment = fragment23;
EGDSTextIconListItem.displayName = "EGDSTextIconListItem";

// ../internal/src/components/egds-list/egds-text-with-mark-list-item.tsx
import React56 from "react";
import { EGDSListItem as EGDSListItem5 } from "@egds/react-core/list";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
import { gql as gql64 } from "@shared-ui/apollo-client-wrapper";
var fragment24 = gql64`
  fragment EGDSTextWithMarkListItemFragment on EGDSTextWithMarkListItem {
    mark {
      ...EGDSMarkFragment
    }
    style
    text
  }

  ${ActivitiesEGDSMark.fragment}
`;
var EGDSTextWithMarkListItem = ({
  data
}) => {
  const {
    text,
    mark,
    style
  } = data;
  const themeProps = style ? textThemeMapper[style] : void 0;
  return /* @__PURE__ */React56.createElement(EGDSListItem5, null, mark && /* @__PURE__ */React56.createElement(ActivitiesEGDSMark, {
    data: mark
  }), /* @__PURE__ */React56.createElement(EGDSText10, {
    theme: themeProps
  }, /* @__PURE__ */React56.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};
EGDSTextWithMarkListItem.fragment = fragment24;
EGDSTextWithMarkListItem.displayName = "EGDSTextWithMarkListItem";

// ../internal/src/components/egds-list/egds-text-list-item.tsx
var fragment25 = gql65`
  fragment EGDSTextListItemFragment on EGDSTextListItem {
    ...EGDSTextStandardListItemFragment
    ...EGDSTextIconListItemFragment
    ...EGDSTextIconLinkListItemFragment
    ...EGDSTextWithMarkListItemFragment
    ...EarnMessageContainerListItemFragment
  }

  ${EGDSTextStandardListItem.fragment}
  ${EGDSTextIconListItem.fragment}
  ${EGDSTextIconLinkListItem.fragment}
  ${EGDSTextWithMarkListItem.fragment}
  ${EarnMessageContainerListItem.fragment}
`;
var EGDSTextListItem = ({
  data
}) => {
  switch (data.__typename) {
    case "EGDSTextStandardListItem":
      return /* @__PURE__ */React57.createElement(EGDSTextStandardListItem, {
        data
      });
    case "EGDSTextIconListItem":
      return /* @__PURE__ */React57.createElement(EGDSTextIconListItem, {
        data
      });
    case "EGDSTextIconLinkListItem":
      return /* @__PURE__ */React57.createElement(EGDSTextIconLinkListItem, {
        data
      });
    case "EGDSTextWithMarkListItem":
      return /* @__PURE__ */React57.createElement(EGDSTextWithMarkListItem, {
        data
      });
    case "EarnMessageContainerListItem":
      return /* @__PURE__ */React57.createElement(EarnMessageContainerListItem, {
        data
      });
    default:
      return null;
  }
};
EGDSTextListItem.fragment = fragment25;
EGDSTextListItem.displayName = "EGDSTextListItem";

// ../internal/src/components/egds-list/egds-bulleted-list.tsx
var fragment26 = gql66`
  fragment EGDSBulletedListFragment on EGDSBulletedList {
    listItems {
      ...EGDSTextListItemFragment
    }
    size
  }

  ${EGDSTextListItem.fragment}
`;
var EGDSBulletedList = ({
  className,
  columns,
  expando,
  data
}) => {
  const {
    listItems,
    size
  } = data;
  if (!listItems.length) {
    return null;
  }
  const sizeProps = size ? textListSizeMapper[size] : void 0;
  const List = props => /* @__PURE__ */React58.createElement(EGDSList2, __spreadValues({
    spacing: false,
    size: sizeProps,
    type: "unordered"
  }, props), listItems.map((item, index) => /* @__PURE__ */React58.createElement(EGDSTextListItem, {
    key: index,
    data: item
  })));
  const ListWithGrid = withEGDSLayoutGrid(List);
  return expando ? /* @__PURE__ */React58.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className,
    data: expando
  }, /* @__PURE__ */React58.createElement(EGDSList2, {
    spacing: false,
    size: sizeProps,
    type: "unordered"
  }, listItems.map((item, index) => /* @__PURE__ */React58.createElement(EGDSTextListItem, {
    key: index,
    data: item
  })))) : /* @__PURE__ */React58.createElement(ListWithGrid, {
    className,
    columns
  });
};
EGDSBulletedList.fragment = fragment26;
EGDSBulletedList.displayName = "EGDSBulletedList";

// ../internal/src/components/egds-list/egds-text-icon-list.tsx
import React59 from "react";
import { withEGDSLayoutGrid as withEGDSLayoutGrid2 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList3 } from "@egds/react-core/list";
import { gql as gql67 } from "@shared-ui/apollo-client-wrapper";
var fragment27 = gql67`
  fragment EGDSTextIconListFragment on EGDSTextIconList {
    listItems {
      ...EGDSTextIconListItemFragment
    }
    size
  }

  ${EGDSTextIconListItem.fragment}
`;
var EGDSTextIconList = ({
  className,
  bullet,
  nestedListBullet,
  columns,
  expando,
  data
}) => {
  const {
    listItems,
    size
  } = data;
  if (!listItems.length) {
    return null;
  }
  const listBulletProp = bullet === "icon-standard" || bullet === "icon-alternate" ? bullet : "icon-standard";
  const sizeProps = size ? textListSizeMapper[size] : void 0;
  const List = props => /* @__PURE__ */React59.createElement(EGDSList3, __spreadValues({
    spacing: false,
    bullet: listBulletProp,
    size: sizeProps,
    type: "unordered"
  }, props), listItems.map((item, index) => /* @__PURE__ */React59.createElement(EGDSTextIconListItem, {
    key: `egds-text-icon-list-item-${index}`,
    nestedListBullet,
    data: item
  })));
  const ListWithGrid = withEGDSLayoutGrid2(List);
  return expando ? /* @__PURE__ */React59.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className,
    data: expando
  }, /* @__PURE__ */React59.createElement(EGDSList3, {
    spacing: false,
    bullet: listBulletProp,
    size: sizeProps,
    type: "unordered"
  }, listItems.map((item, index) => /* @__PURE__ */React59.createElement(EGDSTextIconListItem, {
    key: `egds-text-icon-list-item-${index}`,
    nestedListBullet,
    data: item
  })))) : /* @__PURE__ */React59.createElement(ListWithGrid, {
    className,
    columns
  });
};
EGDSTextIconList.fragment = fragment27;
EGDSTextIconList.displayName = "EGDSTextIconList";

// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React60 from "react";
import { withEGDSLayoutGrid as withEGDSLayoutGrid3 } from "@egds/react-core/layout-grid";
import { EGDSList as EGDSList4 } from "@egds/react-core/list";
import { gql as gql68 } from "@shared-ui/apollo-client-wrapper";
var fragment28 = gql68`
  fragment EGDSUnorderedListFragment on EGDSUnorderedList {
    listItems {
      ...EGDSTextListItemFragment
    }
    size
  }

  ${EGDSTextListItem.fragment}
`;
var EGDSUnorderedList = ({
  className,
  bullet,
  columns,
  expando,
  data
}) => {
  const {
    listItems,
    size
  } = data;
  if (!listItems.length) {
    return null;
  }
  const sizeProps = size ? textListSizeMapper[size] : void 0;
  const List = props => /* @__PURE__ */React60.createElement(EGDSList4, __spreadValues({
    spacing: false,
    bullet,
    size: sizeProps,
    type: "unordered"
  }, props), listItems.map((item, index) => /* @__PURE__ */React60.createElement(EGDSTextListItem, {
    key: index,
    data: item
  })));
  const ListWithGrid = withEGDSLayoutGrid3(List);
  return expando ? /* @__PURE__ */React60.createElement(ActivitiesEGDSExpando, {
    expandoListItemTitleTag: "h6",
    expandoListItemTitleSize: 6,
    expandoPeekItems: 4,
    className,
    data: expando
  }, /* @__PURE__ */React60.createElement(EGDSList4, {
    spacing: false,
    bullet,
    size: sizeProps,
    type: "unordered"
  }, listItems.map((item, index) => /* @__PURE__ */React60.createElement(EGDSTextListItem, {
    key: index,
    data: item
  })))) : /* @__PURE__ */React60.createElement(ListWithGrid, {
    className,
    columns
  });
};
EGDSUnorderedList.fragment = fragment28;
EGDSUnorderedList.displayName = "EGDSUnorderedList";

// ../internal/src/components/egds-list/egds-text-list.tsx
var fragment29 = gql69`
  fragment EGDSTextListFragment on EGDSTextList {
    ... on EGDSUnorderedList {
      ...EGDSUnorderedListFragment
    }
    ... on EGDSBulletedList {
      ...EGDSBulletedListFragment
    }
    ... on EGDSTextIconList {
      ...EGDSTextIconListFragment
    }
  }

  ${EGDSUnorderedList.fragment}
  ${EGDSBulletedList.fragment}
  ${EGDSTextIconList.fragment}
`;
var EGDSTextList = ({
  className,
  bullet,
  columns,
  expando,
  nestedListBullet,
  data
}) => {
  switch (data.__typename) {
    case "EGDSUnorderedList":
      return /* @__PURE__ */React61.createElement(EGDSUnorderedList, {
        className,
        bullet,
        columns,
        data,
        expando
      });
    case "EGDSBulletedList":
      return /* @__PURE__ */React61.createElement(EGDSBulletedList, {
        className,
        columns,
        data,
        expando
      });
    case "EGDSTextIconList":
      return /* @__PURE__ */React61.createElement(EGDSTextIconList, {
        className,
        bullet,
        columns,
        nestedListBullet,
        data,
        expando
      });
    default:
      return null;
  }
};
EGDSTextList.fragment = fragment29;
EGDSTextList.displayName = "EGDSTextList";

// ../internal/src/components/egds-list/egds-link-list.tsx
import React62 from "react";
import { EGDSList as EGDSList5, EGDSListItem as EGDSListItem6 } from "@egds/react-core/list";
import { gql as gql70 } from "@shared-ui/apollo-client-wrapper";
var fragment30 = gql70`
  fragment EGDSLinkListFragment on EGDSLinkList {
    listItems {
      ...EGDSStandardLinkFragment
    }
  }

  ${EGDSStandardLink.fragment}
`;
var EGDSLinkList = ({
  className,
  orientation,
  data
}) => {
  const {
    listItems
  } = data;
  return /* @__PURE__ */React62.createElement(EGDSList5, {
    spacing: false,
    className,
    bullet: "no-bullet",
    orientation
  }, listItems.map((item, index) => /* @__PURE__ */React62.createElement(EGDSListItem6, {
    key: `egds-link-list-${index}`
  }, /* @__PURE__ */React62.createElement(EGDSStandardLink, {
    key: index,
    data: item
  }))));
};
EGDSLinkList.fragment = fragment30;
EGDSLinkList.displayName = "EGDSLinkList";

// ../internal/src/components/activity-card/activity-card-content/activity-card-text-list-content.tsx
var __Fragment24 = gql71`
  fragment ActivityCardTextListContentFragment on ActivityCardTextListContent {
    expando {
      ...EGDSExpandoFragment
    }
    icon {
      ...EGDSGraphicFragment
    }
    heading {
      ...EGDSTextFragment
    }
    list {
      ...EGDSTextListFragment
    }
  }

  ${ActivitiesEGDSExpando.fragment}
  ${EGDSGraphic.fragment}
  ${EGDSTextList.fragment}
  ${ActivitiesEGDSText.fragment}
`;
var topMargin3 = {
  blockstart: "two"
};
var ActivityCardTextListContent = ({
  className,
  bullet,
  nestedListBullet,
  headingSize,
  columns,
  data
}) => {
  const {
    heading,
    list,
    icon,
    expando
  } = data;
  return /* @__PURE__ */React63.createElement("div", {
    className
  }, /* @__PURE__ */React63.createElement(EGDSLayoutFlex8, {
    space: "three"
  }, icon && /* @__PURE__ */React63.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React63.createElement(EGDSGraphic, {
    data: icon
  })), /* @__PURE__ */React63.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React63.createElement("div", null, heading && /* @__PURE__ */React63.createElement(ActivitiesEGDSText, {
    headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React63.createElement(EGDSSpacing12, {
    margin: topMargin3
  }, /* @__PURE__ */React63.createElement(EGDSTextList, {
    bullet,
    columns,
    nestedListBullet,
    expando,
    data: list
  })) : /* @__PURE__ */React63.createElement(EGDSSpacing12, {
    margin: topMargin3
  }, /* @__PURE__ */React63.createElement(EGDSTextList, {
    bullet,
    columns,
    nestedListBullet,
    data: list
  }))))));
};
ActivityCardTextListContent.displayName = "ActivityCardTextListContent";
ActivityCardTextListContent.fragment = __Fragment24;

// ../internal/src/components/activity-card/activity-card-content/activity-card-link-list-content.tsx
import React64 from "react";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { gql as gql72 } from "@shared-ui/apollo-client-wrapper";
var __Fragment25 = gql72`
  fragment ActivityCardLinkListContentFragment on ActivityCardLinkListContent {
    heading {
      ...EGDSHeadingFragment
    }
    list {
      ...EGDSLinkListFragment
    }
  }

  ${EGDSLinkList.fragment}
  ${ActivitiesEGDSHeading.fragment}
`;
var linkListMargin = {
  blockstart: "one"
};
var ActivityCardLinkListContent = ({
  className,
  headingSize,
  orientation,
  data
}) => {
  const {
    heading,
    list
  } = data;
  return /* @__PURE__ */React64.createElement("div", {
    className
  }, heading && /* @__PURE__ */React64.createElement(ActivitiesEGDSHeading, {
    size: headingSize,
    data: heading
  }), /* @__PURE__ */React64.createElement(EGDSSpacing13, {
    margin: linkListMargin
  }, /* @__PURE__ */React64.createElement(EGDSLinkList, {
    data: list,
    orientation
  })));
};
ActivityCardLinkListContent.displayName = "ActivityCardLinkListContent";
ActivityCardLinkListContent.fragment = __Fragment25;

// ../internal/src/components/activity-card/activity-card-content/activity-card-section-content.tsx
import React66 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign3 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { gql as gql74 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/activity-card/activity-card-content/activity-card-reviews-rating-content.tsx
import React65 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { gql as gql73 } from "@shared-ui/apollo-client-wrapper";
var __Fragment26 = gql73`
  fragment ActivityCardReviewsRatingContentFragment on ActivityCardReviewsRatingContent {
    primary {
      ...EGDSTextFragment
    }
    secondaries {
      ...EGDSTextFragment
    }
    disclaimer {
      ...ActivityDisclaimerDialogFragment
    }
    reviewRatingBadge {
      text
      theme
      accessibility
      size
    }
    reviewSuperlative {
      ...EGDSStylizedTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
  ${EGDSStylizedText.fragment}
  ${ActivityDisclaimerDialog.fragment}
`;
var activityDialogTriggerMargin = {
  blockstart: "half"
};
var secondaryTextMargin = {
  inlinestart: "one"
};
var ActivityCardReviewsRatingContent = ({
  className,
  data
}) => {
  const {
    primary,
    secondaries,
    disclaimer,
    reviewRatingBadge,
    reviewSuperlative
  } = data;
  const {
    text,
    theme,
    accessibility,
    size
  } = reviewRatingBadge || {};
  const {
    textSize: superlativeSize
  } = reviewSuperlative || {};
  const getHighlightReviews = () => {
    return /* @__PURE__ */React65.createElement("div", {
      className
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, {
      space: "one",
      alignItems: "center"
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSBadgeStandard, {
      text,
      theme,
      a11yText: accessibility,
      size
    })), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, {
      direction: "column"
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, reviewSuperlative && /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: Number(superlativeSize),
      data: reviewSuperlative
    })), (secondaries == null ? void 0 : secondaries.length) && secondaries.map((secondary, index) => /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, {
      key: `activity-card-reviews-rating-content-${index}`
    }, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: 200,
      data: secondary
    })))))));
  };
  const getReviewsRatings = () => {
    return primary && /* @__PURE__ */React65.createElement("div", {
      className
    }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex9, null, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: 300,
      data: primary
    })), (secondaries == null ? void 0 : secondaries.length) && secondaries.map((secondary, index) => /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, {
      key: `activity-card-reviews-rating-content-${index}`
    }, /* @__PURE__ */React65.createElement(EGDSSpacing14, {
      margin: secondaryTextMargin
    }, /* @__PURE__ */React65.createElement(ActivitiesEGDSText, {
      textSize: 300,
      data: secondary
    })))), disclaimer && /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React65.createElement(EGDSSpacing14, {
      margin: activityDialogTriggerMargin
    }, /* @__PURE__ */React65.createElement(ActivityDisclaimerDialog, {
      data: disclaimer
    })))));
  };
  return reviewRatingBadge ? getHighlightReviews() : getReviewsRatings();
};
ActivityCardReviewsRatingContent.displayName = "ActivityCardReviewsRatingContent";
ActivityCardReviewsRatingContent.fragment = __Fragment26;

// ../internal/src/components/activity-card/activity-card-content/activity-card-section-content.tsx
var __Fragment27 = gql74`
  fragment ActivityCardSectionContentFragment on ActivityCardSectionContent {
    rows {
      ...ActivityCardTextContentFragment
      ...ActivityCardTextListContentFragment
      ...ActivityCardHeadingContentFragment
      ...ActivityCardReviewsRatingContentFragment
      ...ActivityPriceDisplayFragment
      ...ActivityCardLinkListContentFragment
    }
    columns {
      rows {
        ...ActivityCardTextContentFragment
        ...ActivityCardTextListContentFragment
        ...ActivityCardHeadingContentFragment
        ...ActivityCardReviewsRatingContentFragment
        ...ActivityPriceDisplayFragment
        ...ActivityCardLinkListContentFragment
      }
    }
  }

  ${ActivityCardTextContent.fragment}
  ${ActivityCardTextListContent.fragment}
  ${ActivityCardHeadingContent.fragment}
  ${ActivityCardReviewsRatingContent.fragment}
  ${ActivityPriceDisplay.fragment}
  ${ActivityCardLinkListContent.fragment}
`;
var topMargin4 = {
  blockstart: "one"
};
var topMarginForOverview = {
  blockstart: "three"
};
var ActivityCardSectionContent = ({
  cardHeadingContent,
  cardLinkListContent,
  cardTextContent,
  cardTextListContent,
  className,
  isOverviewSection,
  data
}) => {
  const {
    rows,
    columns
  } = data;
  const mapCardContentRows = (row, key) => {
    switch (row.__typename) {
      case "ActivityCardHeadingContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-heading-${key}`,
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardHeadingContent, __spreadProps(__spreadValues({}, cardHeadingContent), {
          data: row
        })));
      case "ActivityCardLinkListContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-link-list-${key}`,
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardLinkListContent, __spreadProps(__spreadValues({}, cardLinkListContent), {
          data: row
        })));
      case "ActivityCardTextContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-text-${key}`,
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardTextContent, __spreadProps(__spreadValues({}, cardTextContent), {
          data: row
        })));
      case "ActivityCardTextListContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-text-list-${key}`,
          margin: isOverviewSection ? topMarginForOverview : topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardTextListContent, __spreadProps(__spreadValues({}, cardTextListContent), {
          data: row
        })));
      case "ActivityCardReviewsRatingContent":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-reviews-rating-${key}`,
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityCardReviewsRatingContent, {
          data: row
        }));
      case "ActivityPriceDisplay":
        return /* @__PURE__ */React66.createElement(EGDSSpacing15, {
          key: `activity-card-section-content-price-display-${key}`,
          margin: topMargin4
        }, /* @__PURE__ */React66.createElement(ActivityPriceDisplay, {
          align: EGDSPriceLockupAlign3.LEFT,
          data: row
        }));
      default:
        return null;
    }
  };
  if (columns.length) {
    return /* @__PURE__ */React66.createElement("section", {
      className,
      "data-stid": "activity-card-section"
    }, /* @__PURE__ */React66.createElement(EGDSLayoutGrid4, {
      columns: {
        small: 1,
        medium: columns.length
      },
      space: "six"
    }, columns.map((column, index) => column.rows.length > 0 ? /* @__PURE__ */React66.createElement(EGDSLayoutGridItem4, {
      key: `activity-card-section-column-${index}`
    }, /* @__PURE__ */React66.createElement("div", null, column.rows.map(row => mapCardContentRows(row, index)))) : null)));
  }
  return rows.length ? /* @__PURE__ */React66.createElement("section", {
    className,
    "data-stid": "activity-card-section"
  }, rows.map((row, index) => mapCardContentRows(row, index))) : null;
};
ActivityCardSectionContent.displayName = "ActivityCardSectionContent";
ActivityCardSectionContent.fragment = __Fragment27;

// ../internal/src/components/activity-card/activity-card-content/activity-card-html-content.tsx
import React67 from "react";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
import { EGDSUnformattedHtml } from "@egds/react-core/unformatted-html";
import { gql as gql75 } from "@shared-ui/apollo-client-wrapper";
var __Fragment28 = gql75`
  fragment ActivityCardHtmlContentFragment on ActivityCardHtmlContent {
    expando {
      ...EGDSExpandoFragment
    }
    heading {
      ...EGDSTextFragment
    }
    text
  }

  ${ActivitiesEGDSExpando.fragment}
  ${ActivitiesEGDSText.fragment}
`;
var topMargin5 = {
  blockstart: "two"
};
var ActivityCardHtmlContent = ({
  className,
  headingSize,
  textSize,
  data
}) => {
  const {
    heading,
    text,
    expando
  } = data;
  return /* @__PURE__ */React67.createElement("div", {
    className
  }, heading && /* @__PURE__ */React67.createElement(ActivitiesEGDSText, {
    headingSize,
    data: heading
  }), expando ? /* @__PURE__ */React67.createElement(EGDSSpacing16, {
    margin: topMargin5
  }, /* @__PURE__ */React67.createElement(ActivitiesEGDSExpando, {
    expandoPeekLines: 4,
    data: expando
  }, /* @__PURE__ */React67.createElement(EGDSUnformattedHtml, {
    htmlToParse: text
  }))) : /* @__PURE__ */React67.createElement(EGDSSpacing16, {
    margin: topMargin5
  }, /* @__PURE__ */React67.createElement(EGDSText11, {
    size: textSize
  }, /* @__PURE__ */React67.createElement(EGDSUnformattedHtml, {
    htmlToParse: text
  }))));
};
ActivityCardHtmlContent.displayName = "ActivityCardHtmlContent";
ActivityCardHtmlContent.fragment = __Fragment28;

// ../internal/src/components/egds-banner/egds-banner.tsx
import React68 from "react";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6, EGDSText as EGDSText12 } from "@egds/react-core/text";
import { gql as gql76 } from "@shared-ui/apollo-client-wrapper";
var fragment31 = gql76`
  fragment EGDSBannerFragment on UIBanner {
    message
    heading
    icon {
      ...EGDSIconFragment
    }
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var ActivitiesEGDSBanner = ({
  fullWidth,
  data
}) => {
  var _a;
  const {
    message,
    heading,
    icon
  } = data;
  return /* @__PURE__ */React68.createElement(EGDSBanner, {
    fullWidth: fullWidth != null ? fullWidth : false
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlex10, {
    alignItems: "center",
    space: "two"
  }, icon && /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React68.createElement(EGDSSpacing17, {
    margin: {
      inlinestart: "four",
      inlineend: "six"
    }
  }, /* @__PURE__ */React68.createElement(EGDSIcon3, {
    name: icon.id,
    description: icon.description,
    title: (_a = icon.title) != null ? _a : void 0
  }))), /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(EGDSHeading6, null, heading), /* @__PURE__ */React68.createElement(EGDSText12, {
    theme: "inverse"
  }, message)))));
};
ActivitiesEGDSBanner.fragment = fragment31;
ActivitiesEGDSBanner.displayName = "ActivitiesEGDSBanner";

// src/components/offers/__private/__fragments/offer-details-card/offer-details-card.tsx
import { gql as gql84, useLazyQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";

// src/components/offers/__private/__fragments/offer-details-card/offer-price-details.tsx
import React73 from "react";
import { EGDSBadgeSize } from "@egds/react-core/badge";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSPriceLockupAlign as EGDSPriceLockupAlign4 } from "@egds/react-core/price-lockup";
import { EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";

// ../internal/src/components/egds-badge/egds-badge.tsx
import React70 from "react";
import { gql as gql78 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React69 from "react";
import { EGDSBadge, EGDSBadgeLoyalty } from "@egds/react-core/badge";
import { gql as gql77 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/__private/badge-theme.ts
import { EGDSBadgeLoyaltyThemes, EGDSBadgeTheme } from "@egds/react-core/badge";
var badgeThemeToEGDSTheme = {
  DEAL_BUNDLED: EGDSBadgeTheme.DEAL_BUNDLED,
  DEAL_GENERIC: EGDSBadgeTheme.DEAL_GENERIC,
  DEAL_MEMBER: EGDSBadgeTheme.DEAL_MEMBER,
  NOTIFICATION_1: EGDSBadgeTheme.NOTIFICATION_1,
  NOTIFICATION_2: EGDSBadgeTheme.NOTIFICATION_2,
  VIP: EGDSBadgeTheme.VIP,
  LOYALTY_HIGH_TIER: EGDSBadgeTheme.LOYALTY_HIGH_TIER,
  LOYALTY_MIDDLE_TIER: EGDSBadgeTheme.LOYALTY_MIDDLE_TIER,
  LOYALTY_LOW_TIER: EGDSBadgeTheme.LOYALTY_LOW_TIER,
  SPONSORED: EGDSBadgeTheme.SPONSORED,
  VIEWED: EGDSBadgeTheme.VIEWED,
  SAVED: EGDSBadgeTheme.SAVED,
  FAMILY_FRIENDLY: EGDSBadgeTheme.FAMILY_FRIENDLY,
  SUPPLIER_PROMO: EGDSBadgeTheme.SUPPLIER_PROMO
};
var loyaltyBadgeThemeToEGDSTheme = {
  GLOBAL_LOW_TIER: EGDSBadgeLoyaltyThemes.GLOBAL_LOW
};

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var __EGDSStandardBadgeFragment = gql77`
  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {
    accessibility
    graphic {
      ...EGDSGraphicFragment
    }
    text
    theme
  }

  ${EGDSGraphic.fragment}
`;
var EGDSStandardBadge = ({
  className,
  size,
  data
}) => {
  const {
    graphic,
    text,
    theme
  } = data;
  if (!text) {
    return null;
  }
  if (theme && loyaltyBadgeThemeToEGDSTheme[theme]) {
    return /* @__PURE__ */React69.createElement(EGDSBadgeLoyalty, {
      className,
      size,
      theme: loyaltyBadgeThemeToEGDSTheme[theme],
      text
    }, graphic && /* @__PURE__ */React69.createElement(EGDSGraphic, {
      data: graphic
    }));
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */
    React69.createElement(EGDSBadge, {
      className,
      size,
      theme: theme ? badgeThemeToEGDSTheme[theme] : void 0,
      text
    }, graphic && /* @__PURE__ */React69.createElement(EGDSGraphic, {
      data: graphic
    }))
  );
};
EGDSStandardBadge.fragment = __EGDSStandardBadgeFragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";

// ../internal/src/components/egds-badge/egds-badge.tsx
var __EGDSBadgeFragment = gql78`
  fragment EGDSBadgeFragment on EGDSBadge {
    ...EGDSStandardBadgeFragment
  }

  ${EGDSStandardBadge.fragment}
`;
var ActivitiesEGDSBadge = ({
  className,
  size,
  data
}) => {
  switch (data.__typename) {
    case "EGDSStandardBadge":
      return /* @__PURE__ */React70.createElement(EGDSStandardBadge, {
        className,
        size,
        data
      });
    default:
      return null;
  }
};
ActivitiesEGDSBadge.fragment = __EGDSBadgeFragment;
ActivitiesEGDSBadge.displayName = "ActivitiesEGDSBadge";

// src/components/offers/__private/__fragments/offer-details-card/offer-price-details.tsx
import { gql as gql81 } from "@shared-ui/apollo-client-wrapper";

// src/components/offers/__private/__fragments/offer-details-card/offer-price-details-footer-element.tsx
import React71 from "react";
import { EGDSMoreInfoTrigger as EGDSMoreInfoTrigger2 } from "@egds/react-core/more-info-trigger";
import { gql as gql79 } from "@shared-ui/apollo-client-wrapper";
var __Fragment29 = gql79`
  fragment OfferPriceDetailsFooterElementFragment on ActivityOfferPriceDetailsFooterElement {
    ... on ActivityDisclaimerDialog {
      ...ActivityDisclaimerDialogFragment
    }

    ... on EGDSPlainText {
      ...EGDSPlainTextFragment
    }
  }

  ${ActivityDisclaimerDialog.fragment}
  ${EGDSPlainText.fragment}
`;
var OfferPriceDetailsFooterElement = ({
  className,
  data,
  isNestedDialog
}) => {
  var _a;
  const positiveTheme = data.__typename === "ActivityDisclaimerDialog" && data.trigger.__typename === "ActivityLinkDialogTrigger" && ((_a = data.trigger.linkGraphic) == null ? void 0 : _a.__typename) === "Icon" && data.trigger.linkGraphic.theme === "positive";
  switch (data.__typename) {
    case "ActivityDisclaimerDialog":
      return /* @__PURE__ */React71.createElement("div", {
        className
      }, /* @__PURE__ */React71.createElement(EGDSMoreInfoTrigger2, {
        theme: positiveTheme ? "positive" : void 0
      }, /* @__PURE__ */React71.createElement(ActivityDisclaimerDialog, {
        data,
        linkIconPosition: "LEADING" /* LEADING */
      })));
    case "EGDSPlainText":
      return /* @__PURE__ */React71.createElement(EGDSPlainText, {
        className,
        align: "right",
        size: 200,
        data
      });
    default:
      return null;
  }
};
OfferPriceDetailsFooterElement.displayName = "OfferPriceDetailsFooterElement";
OfferPriceDetailsFooterElement.fragment = __Fragment29;

// src/components/offers/__private/__fragments/offer-details-card/offer-price-line-items.tsx
import React72 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSPriceLockup as EGDSPriceLockup2 } from "@egds/react-core/price-lockup";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { gql as gql80 } from "@shared-ui/apollo-client-wrapper";
var __Fragment30 = gql80`
  fragment OfferPriceLineItemsFragment on ActivityOfferPriceLineItems {
    accessibility
    lockupPrice
    priceBreakdown
    strikeThroughPrice
  }
`;
var priceLockupMargin2 = {
  inlineend: "two",
  blockstart: "three"
};
var OfferPriceLineItems = ({
  data: {
    accessibility,
    lockupPrice,
    priceBreakdown,
    strikeThroughPrice
  }
}) => /* @__PURE__ */React72.createElement(EGDSLayoutFlex11, {
  "aria-label": accessibility
}, strikeThroughPrice && /* @__PURE__ */React72.createElement(EGDSSpacing18, {
  margin: priceLockupMargin2
}, /* @__PURE__ */React72.createElement(EGDSPriceLockup2, {
  a11yPrice: strikeThroughPrice,
  strikeThroughPrice
})), /* @__PURE__ */React72.createElement(EGDSText13, {
  spacing: "three",
  inline: true
}, priceBreakdown), /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem9, {
  grow: 1
}, /* @__PURE__ */React72.createElement(EGDSText13, {
  align: "right",
  spacing: "three",
  inline: true
}, lockupPrice)));
OfferPriceLineItems.displayName = "OfferPriceLineItems";
OfferPriceLineItems.fragment = __Fragment30;

// src/components/offers/__private/__fragments/offer-details-card/offer-price-details.tsx
var __Fragment31 = gql81`
  fragment OfferPriceDetailsFragment on ActivityOfferPriceDetails {
    badge {
      ...EGDSBadgeFragment
    }
    detailsTitle
    footer {
      ...OfferPriceDetailsFooterElementFragment
    }
    lineItems {
      ...OfferPriceLineItemsFragment
    }
    priceDisplay {
      ...ActivityPriceDisplayFragment
    }
    totalTitle
  }

  ${ActivityPriceDisplay.fragment}
  ${ActivitiesEGDSBadge.fragment}
  ${OfferPriceLineItems.fragment}
  ${OfferPriceDetailsFooterElement.fragment}
`;
var OfferPriceDetails = ({
  className,
  data,
  isNestedDialog
}) => {
  const {
    badge,
    detailsTitle,
    totalTitle,
    priceDisplay,
    lineItems,
    footer
  } = data;
  return /* @__PURE__ */React73.createElement("div", {
    className
  }, /* @__PURE__ */React73.createElement(EGDSText14, {
    size: 300,
    weight: "medium"
  }, detailsTitle), lineItems.map((lineItem, index) => /* @__PURE__ */React73.createElement(OfferPriceLineItems, {
    key: `price-line-items-key-${index}`,
    data: lineItem
  })), /* @__PURE__ */React73.createElement(EGDSSpacingHr2, null), /* @__PURE__ */React73.createElement(EGDSLayoutGrid5, {
    areas: ["title priceDisplay", "title badge", "title element", "title element"],
    columns: ["min-content", "1fr"],
    space: "three",
    justifyItems: "end"
  }, /* @__PURE__ */React73.createElement(EGDSLayoutGridItem5, {
    area: "title"
  }, /* @__PURE__ */React73.createElement(EGDSText14, {
    size: 300,
    weight: "medium"
  }, totalTitle)), /* @__PURE__ */React73.createElement(EGDSLayoutGridItem5, {
    area: "priceDisplay"
  }, /* @__PURE__ */React73.createElement(ActivityPriceDisplay, {
    align: EGDSPriceLockupAlign4.RIGHT,
    data: priceDisplay
  })), badge && /* @__PURE__ */React73.createElement(EGDSLayoutGridItem5, {
    area: "badge"
  }, /* @__PURE__ */React73.createElement(EGDSText14, {
    align: "right"
  }, /* @__PURE__ */React73.createElement(ActivitiesEGDSBadge, {
    size: EGDSBadgeSize.LARGE,
    data: badge
  }))), footer == null ? void 0 : footer.map((element, index) => /* @__PURE__ */React73.createElement(EGDSLayoutGridItem5, {
    key: `offer-price-details-footer-element-${index}`,
    area: "element"
  }, /* @__PURE__ */React73.createElement(OfferPriceDetailsFooterElement, {
    data: element,
    isNestedDialog
  })))));
};
OfferPriceDetails.displayName = "OfferPriceDetails";
OfferPriceDetails.fragment = __Fragment31;

// src/components/offers/__private/__fragments/offer-details-card/offer-selection-element.tsx
import React75 from "react";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { gql as gql83 } from "@shared-ui/apollo-client-wrapper";

// src/components/offers/__private/__fragments/offer-details-card/offer-selection-graphic-text.tsx
import React74 from "react";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { gql as gql82 } from "@shared-ui/apollo-client-wrapper";
var __Fragment32 = gql82`
  fragment OfferSelectionGraphicTextFragment on ActivityOfferSelectionGraphicText {
    graphicText {
      ...EGDSGraphicTextFragment
    }
    key
    value
  }

  ${EGDSGraphicText.fragment}
`;
var topMargin6 = {
  blockstart: "three"
};
var OfferSelectionGraphicText = ({
  data
}) => /* @__PURE__ */React74.createElement(EGDSSpacing19, {
  margin: topMargin6
}, /* @__PURE__ */React74.createElement(EGDSGraphicText, {
  size: 300,
  data: data.graphicText
}));
OfferSelectionGraphicText.displayName = "OfferSelectionGraphicText";
OfferSelectionGraphicText.fragment = __Fragment32;

// src/components/offers/__private/__fragments/offer-details-card/offer-selection-element.tsx
var __Fragment33 = gql83`
  fragment OfferSelectionElementFragment on ActivityOfferSelectionElement {
    ... on ActivityOfferSelectionGraphicText {
      ...OfferSelectionGraphicTextFragment
    }

    ... on ActivityTravelerSelectorDialog {
      ...ActivityTravelerSelectorDialogFragment
    }

    ... on ActivityRadioGroupDialog {
      ...ActivityRadioGroupDialogFragment
    }
  }

  ${ActivityTravelerSelectorDialog.fragment}
  ${ActivityRadioGroupDialog.fragment}
  ${OfferSelectionGraphicText.fragment}
`;
var topMargin7 = {
  blockstart: "three"
};
var OfferSelectionElement = ({
  handleRadioGroupDoneClick,
  handleTravelerSelectorDoneClick,
  isNestedDialog,
  autoFocus,
  data
}) => {
  switch (data.__typename) {
    case "ActivityTravelerSelectorDialog":
      return /* @__PURE__ */React75.createElement(ActivityTravelerSelectorDialog, {
        doneClickHandler: handleTravelerSelectorDoneClick,
        data,
        isNestedDialog,
        autoFocus
      });
    case "ActivityRadioGroupDialog":
      return /* @__PURE__ */React75.createElement(EGDSSpacing20, {
        margin: topMargin7
      }, /* @__PURE__ */React75.createElement(ActivityRadioGroupDialog, {
        doneClickHandler: handleRadioGroupDoneClick,
        data,
        isNestedDialog
      }));
    case "ActivityOfferSelectionGraphicText":
      return /* @__PURE__ */React75.createElement(OfferSelectionGraphicText, {
        data
      });
    default:
      return null;
  }
};
OfferSelectionElement.displayName = "OfferSelectionElement";
OfferSelectionElement.fragment = __Fragment33;

// src/components/offers/__private/__fragments/offer-details-card/offer-details-card.tsx
var __Fragment34 = gql84`
  fragment OfferDetailsCardFragment on ActivityOfferDetailsCard {
    elementId
    heading
    features {
      ...ActivityCardTextListContentFragment
    }
    description {
      ...EGDSParagraphFragment
    }
    priceDetails {
      ...OfferPriceDetailsFragment
    }
    selections {
      ...OfferSelectionElementFragment
    }
    bookButton {
      ...EGDSButtonFragment
    }
    activitySignIn {
      ...ActivitySignInDialogFragment
    }
    createTripAction {
      clientSideAnalytics {
        referrerId
        linkName
      }
      createTripRequestBody
    }
    errorMessages {
      ...ActivityOfferBookingErrorBannerFragment
    }
  }

  fragment ActivitySignInDialogFragment on ActivitySignInDialog {
    activityMemberSignIn {
      ...ActivityMemberSignInFragment
    }
  }

  fragment ActivityOfferBookingErrorBannerFragment on ActivityOfferBookingErrorBanner {
    statusCode
    banner {
      ...EGDSBannerFragment
    }
    clientSideAnalytics {
      referrerId
      linkName
    }
  }

  ${ActivityCardTextListContent.fragment}
  ${ActivitiesEGDSParagraph.fragment}
  ${ActivitiesEGDSButton.fragment}
  ${OfferSelectionElement.fragment}
  ${OfferPriceDetails.fragment}
  ${ActivitiesEGDSBanner.fragment}
  ${ActivitySignInDialog.fragment}
`;
var __OfferDetailsCardLazyQuery = gql84`
  query OfferDetailsCardLazyQuery(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
    $offerId: String!
    $selectedDate: DateInput!
  ) {
    activityInfo(
      context: $context
      activityId: $activityId
      dateRange: $dateRange
      destination: $destination
      detailsViewOptions: $detailsViewOptions
      offerFilters: $offerFilters
    ) {
      offerComponent(offerId: $offerId, selectedDate: $selectedDate) {
        ...OfferDetailsCardFragment
      }
    }
  }

  ${__Fragment34}
`;
var topMargin8 = {
  small: {
    blockstart: "three"
  },
  large: {
    blockstart: "six"
  }
};
var gridColumns2 = {
  medium: 2,
  large: 3
};
var gridRows = {
  medium: [Repeat(2, "min-content")],
  large: 1
};
var htmlElementsToReplace = __spreadProps(__spreadValues({}, EGDSUnformattedHtmlReplaceDefaults), {
  // eslint-disable-next-line react/display-name
  p: ({
    children
  }) => /* @__PURE__ */React76.createElement(EGDSParagraph3, {
    size: 3
  }, children)
});
var getPlainTextFromHtml = ({
  children
}) => /* @__PURE__ */React76.createElement(EGDSParagraph3, {
  size: 3
}, children);
var OfferDetailsCard = ({
  className,
  data,
  loading,
  detailsViewOptions,
  selectedDate,
  selectedDateRange,
  createTripOnClick,
  setCreateTripLoading,
  isNestedDialog
}) => {
  const {
    context
  } = useBexApi();
  const {
    inputs
  } = useOffersInputsContext();
  const clickTracker = useClickTracker20();
  const [offerDetailCardData, setOfferDetailCardData] = React76.useState(data);
  const [offerDetailsCardFilters, setOfferDetailsCardFilter] = React76.useState(offerDetailsCardInitializer(data));
  const [errorBanner, setErrorBanner] = React76.useState();
  const [travelerSelectionFocus, setTravelerSelectionFocus] = React76.useState(false);
  const {
    elementId,
    heading,
    features,
    description,
    priceDetails,
    selections,
    bookButton,
    activitySignIn,
    createTripAction: {
      clientSideAnalytics,
      createTripRequestBody
    },
    errorMessages
  } = offerDetailCardData;
  const [offerDetailsCardLazyQuery, options] = useLazyQuery(__OfferDetailsCardLazyQuery, {
    onCompleted: results => {
      const {
        offerComponent
      } = results.activityInfo;
      setOfferDetailCardData(offerComponent);
      setTravelerSelectionFocus(false);
    },
    fetchPolicy: "no-cache",
    ssr: false
  });
  const [, dialogActionForSignInDialog] = useDialog9("activity-signin-dialog");
  const signInExperiment = useExperiment("SignIn_Popup_for_Guest_Users");
  const partnerOnboardingExperiment = useExperiment("Opensite_Partner_Onboarding");
  const shouldDisplaySignInDialog = signInExperiment.exposure.bucket > 0 || partnerOnboardingExperiment.exposure.bucket > 0;
  const activitySignInDialog = activitySignIn == null ? void 0 : activitySignIn.activityMemberSignIn;
  const handleTravelerSelectorDoneClick = React76.useCallback(tickets => {
    const newFilters = __spreadValues(__spreadValues({}, offerDetailsCardFilters), {
      tickets
    });
    setOfferDetailsCardFilter(newFilters);
    if (selectedDate) {
      const variables = {
        context,
        activityId: inputs.activityId,
        destination: inputs.destination,
        offerId: elementId,
        offerFilters: newFilters,
        dateRange: selectedDateRange,
        detailsViewOptions,
        selectedDate
      };
      offerDetailsCardLazyQuery({
        variables
      });
      setTravelerSelectionFocus(true);
    }
  }, [offerDetailsCardFilters, context, elementId, inputs.activityId, inputs.destination, detailsViewOptions, selectedDateRange, selectedDate, offerDetailsCardLazyQuery, setOfferDetailsCardFilter]);
  const handleRadioGroupDoneClick = React76.useCallback((groupName, selected) => {
    var _a;
    const newSelections = (_a = offerDetailsCardFilters.selections) == null ? void 0 : _a.map(selection => {
      if (selection.id === groupName) {
        return {
          id: groupName,
          value: selected
        };
      }
      return selection;
    });
    const newFilters = __spreadValues(__spreadValues({}, offerDetailsCardFilters), {
      selections: newSelections
    });
    setOfferDetailsCardFilter(newFilters);
    if (selectedDate) {
      const variables = {
        context,
        activityId: inputs.activityId,
        destination: inputs.destination,
        offerId: elementId,
        offerFilters: newFilters,
        dateRange: selectedDateRange,
        detailsViewOptions,
        selectedDate
      };
      offerDetailsCardLazyQuery({
        variables
      });
    }
  }, [offerDetailsCardFilters, context, elementId, inputs.activityId, inputs.destination, detailsViewOptions, selectedDateRange, selectedDate, offerDetailsCardLazyQuery, setOfferDetailsCardFilter]);
  const handleBookButtonOnClick = React76.useCallback(async () => {
    if (shouldDisplaySignInDialog && activitySignInDialog) {
      dialogActionForSignInDialog.openDialog();
    } else {
      setCreateTripLoading == null ? void 0 : setCreateTripLoading(true);
      const response = await (createTripOnClick == null ? void 0 : createTripOnClick(createTripRequestBody));
      const error = errorMessages == null ? void 0 : errorMessages.find(errorMessage => errorMessage.statusCode === response);
      if (error) {
        clickTracker(error.clientSideAnalytics.referrerId, error.clientSideAnalytics.referrerId);
        setErrorBanner(error.banner);
      }
      setCreateTripLoading == null ? void 0 : setCreateTripLoading(false);
    }
  }, [createTripRequestBody, setErrorBanner]);
  React76.useEffect(() => {
    setOfferDetailCardData(data);
    setOfferDetailsCardFilter(offerDetailsCardInitializer(data));
  }, [data]);
  if (loading || options.loading) {
    return /* @__PURE__ */React76.createElement(EGDSCard3, {
      className
    }, /* @__PURE__ */React76.createElement(EGDSCardPlaceholder, {
      startPhase: "light",
      aspectRatio: "r1-4"
    }));
  }
  const buttonAnalytics = {
    description: clientSideAnalytics.linkName,
    id: clientSideAnalytics.referrerId,
    callback: (referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }
  };
  return /* @__PURE__ */React76.createElement(React76.Fragment, null, /* @__PURE__ */React76.createElement(EGDSCard3, {
    className,
    padded: true,
    border: true
  }, /* @__PURE__ */React76.createElement(EGDSLayoutGrid6, {
    columns: gridColumns2,
    rows: gridRows,
    space: "six"
  }, /* @__PURE__ */React76.createElement(EGDSLayoutGridItem6, {
    colSpan: {
      medium: 2,
      large: 1
    }
  }, /* @__PURE__ */React76.createElement("div", null, /* @__PURE__ */React76.createElement(EGDSHeading7, {
    size: 5,
    tag: "h5"
  }, heading), features && /* @__PURE__ */React76.createElement(EGDSSpacing21, {
    margin: topMargin8
  }, /* @__PURE__ */React76.createElement(ActivityCardTextListContent, {
    bullet: "icon-standard",
    data: features
  })), description && /* @__PURE__ */React76.createElement(EGDSSpacing21, {
    margin: topMargin8
  }, /* @__PURE__ */React76.createElement("div", null, /* @__PURE__ */React76.createElement(EGDSUnformattedHtml2, {
    htmlToParse: description.text,
    elementsToReplace: htmlElementsToReplace,
    plainTextElement: getPlainTextFromHtml
  }))), /* @__PURE__ */React76.createElement(Viewport2, null, /* @__PURE__ */React76.createElement(ViewMedium2, null, /* @__PURE__ */React76.createElement(EGDSSpacingHr3, null)), /* @__PURE__ */React76.createElement(ViewLarge, null)))), /* @__PURE__ */React76.createElement(EGDSLayoutGridItem6, {
    colStart: {
      medium: 1,
      large: 2
    },
    rowStart: {
      medium: 2,
      large: 1
    }
  }, /* @__PURE__ */React76.createElement("div", null, selections == null ? void 0 : selections.map((element, index) => /* @__PURE__ */React76.createElement(OfferSelectionElement, {
    key: `offer-selection-element-${index}`,
    handleRadioGroupDoneClick,
    handleTravelerSelectorDoneClick,
    data: element,
    isNestedDialog,
    autoFocus: travelerSelectionFocus
  })))), /* @__PURE__ */React76.createElement(EGDSLayoutGridItem6, {
    colStart: {
      medium: 2,
      large: 3
    },
    rowStart: {
      medium: 2,
      large: 1
    }
  }, /* @__PURE__ */React76.createElement(EGDSLayoutFlex12, {
    space: "six",
    direction: "column",
    justifyContent: "space-between"
  }, /* @__PURE__ */React76.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React76.createElement(OfferPriceDetails, {
    data: priceDetails,
    isNestedDialog
  })), errorBanner ? /* @__PURE__ */React76.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React76.createElement(EGDSSpacing21, {
    margin: topMargin8
  }, /* @__PURE__ */React76.createElement(ActivitiesEGDSBanner, {
    fullWidth: false,
    data: errorBanner
  }))) : null, /* @__PURE__ */React76.createElement(Viewport2, null, /* @__PURE__ */React76.createElement(ViewSmall2, null, /* @__PURE__ */React76.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React76.createElement("div", {
    "data-testid": "offer-book-button"
  }, /* @__PURE__ */React76.createElement(ActivitiesEGDSButton, {
    analytics: buttonAnalytics,
    size: EGDSButtonSize4.MEDIUM,
    data: bookButton,
    onClickHandler: handleBookButtonOnClick
  })))), /* @__PURE__ */React76.createElement(ViewMedium2, null, /* @__PURE__ */React76.createElement(EGDSLayoutFlexItem10, {
    alignSelf: "end"
  }, /* @__PURE__ */React76.createElement("div", {
    "data-testid": "offer-book-button"
  }, /* @__PURE__ */React76.createElement(ActivitiesEGDSButton, {
    analytics: buttonAnalytics,
    onClickHandler: handleBookButtonOnClick,
    size: EGDSButtonSize4.MEDIUM,
    data: bookButton
  }))))))))), activitySignInDialog && /* @__PURE__ */React76.createElement(ActivitySignInDialog, {
    data: activitySignInDialog,
    dialogId: "activity-signin-dialog"
  }));
};
OfferDetailsCard.displayName = "OfferDetailsCard";
OfferDetailsCard.fragment = __Fragment34;

// src/components/offers/__private/__fragments/offer-message.tsx
import React77 from "react";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText15 } from "@egds/react-core/text";
import { gql as gql85 } from "@shared-ui/apollo-client-wrapper";
var __Fragment35 = gql85`
  fragment OfferMessageFragment on ActivityOfferMessage {
    primary
    secondaries
  }
`;
var offerMessageMargin = {
  block: "six"
};
var OfferMessage = ({
  data
}) => {
  const {
    primary,
    secondaries
  } = data;
  return /* @__PURE__ */React77.createElement(EGDSSpacing22, {
    margin: offerMessageMargin
  }, /* @__PURE__ */React77.createElement("div", null, /* @__PURE__ */React77.createElement(EGDSHeading8, {
    size: 6,
    tag: "h6"
  }, primary), secondaries == null ? void 0 : secondaries.map((text, index) => /* @__PURE__ */React77.createElement(EGDSText15, {
    key: `offer-message-key-${index}`,
    size: 300,
    spacing: "three"
  }, text))));
};
OfferMessage.displayName = "OfferMessage";
OfferMessage.fragment = __Fragment35;

// src/components/offers/__private/__fragments/offers-list/offers-list-filter-pills.tsx
import React81 from "react";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";

// ../internal/src/components/egds-pill/egds-pill.tsx
import React80 from "react";
import { gql as gql88 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-pill/egds-basic-pill.tsx
import React78 from "react";
import { EGDSPill } from "@egds/react-core/pill";
import { gql as gql86 } from "@shared-ui/apollo-client-wrapper";
var __Fragment36 = gql86`
  fragment EGDSBasicPillFragment on EGDSBasicPill {
    accessibility
    disabled
    name
    primary
    value
  }
`;
var EGDSBasicPill = ({
  className,
  onChange,
  data
}) => {
  const {
    accessibility,
    disabled,
    name,
    primary,
    value
  } = data;
  const [isChecked, setIsChecked] = React78.useState(false);
  const handleOnChange = React78.useCallback(event => {
    setIsChecked(!isChecked);
    if (onChange) {
      onChange(event);
    }
  }, [isChecked, onChange]);
  if (!name || !primary || !value) {
    return null;
  }
  return /* @__PURE__ */React78.createElement(EGDSPill, {
    id: `activity-pill-${name}-${value}`,
    altText: accessibility != null ? accessibility : void 0,
    className,
    checked: isChecked,
    disabled,
    name,
    onChange: handleOnChange,
    value
  }, primary);
};
EGDSBasicPill.fragment = __Fragment36;
EGDSBasicPill.displayName = "EGDSBasicPill";

// ../internal/src/components/egds-pill/egds-basic-removable-pill.tsx
import React79 from "react";
import { EGDSRemovablePill } from "@egds/react-core/pill";
import { gql as gql87 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
var fragment32 = gql87`
  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {
    accessibility
    disabled
    icon {
      ...EGDSGraphicFragment
    }
    name
    primary
    remove {
      ...EGDSGraphicFragment
    }
    removeAnalytics {
      ...ClientSideAnalyticsFragment
    }
    selected
    value
  }

  ${EGDSGraphic.fragment}
  ${clientSideAnalyticsFragment}
`;
var EGDSBasicRemovablePill = ({
  data,
  onClickCallback
}) => {
  const trackClick = useClickTracker21();
  const {
    accessibility,
    disabled,
    icon,
    primary,
    removeAnalytics,
    value
  } = data;
  const clickHandle = React79.useCallback(() => {
    if (removeAnalytics) {
      trackClick(removeAnalytics.referrerId, removeAnalytics.linkName);
    }
    if (onClickCallback) {
      onClickCallback();
    }
  }, [onClickCallback]);
  if (!primary || !value) {
    return null;
  }
  return /* @__PURE__ */React79.createElement(EGDSRemovablePill, {
    id: value || "pill",
    disabled,
    onClick: clickHandle,
    altText: accessibility || void 0,
    value: value || void 0,
    icon: (icon == null ? void 0 : icon.__typename) === "Icon" ? icon.id : void 0
  }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = fragment32;

// ../internal/src/components/egds-pill/egds-pill.tsx
var __Fragment37 = gql88`
  fragment EGDSPillFragment on EGDSPill {
    ...EGDSBasicPillFragment
    ...EGDSBasicRemovablePillFragment
  }

  ${EGDSBasicPill.fragment}
  ${EGDSBasicRemovablePill.fragment}
`;
var ActivitiesEGDSPill = ({
  className,
  onChange,
  onClickCallback,
  data
}) => {
  switch (data.__typename) {
    case "EGDSBasicPill":
      return /* @__PURE__ */React80.createElement(EGDSBasicPill, {
        className,
        onChange,
        data
      });
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React80.createElement(EGDSBasicRemovablePill, {
        data,
        onClickCallback
      });
    default:
      return null;
  }
};
ActivitiesEGDSPill.fragment = __Fragment37;
ActivitiesEGDSPill.displayName = "ActivitiesEGDSPill";

// src/components/offers/__private/__fragments/offers-list/offers-list-filter-pills.tsx
import { gql as gql89 } from "@shared-ui/apollo-client-wrapper";
var __Fragment38 = gql89`
  fragment OffersListFilterPillsFragment on ActivityOffersListFilterPills {
    heading
    pills {
      ...EGDSBasicPillFragment
    }
  }

  ${EGDSBasicPill.fragment}
`;
var topMargin9 = {
  blockstart: "two"
};
var OffersListFilterPills = ({
  className,
  onChange,
  data
}) => {
  const {
    heading,
    pills
  } = data;
  return /* @__PURE__ */React81.createElement("div", {
    className
  }, heading && /* @__PURE__ */React81.createElement(EGDSHeading9, {
    tag: "h6",
    size: 8
  }, heading), /* @__PURE__ */React81.createElement(EGDSSpacing23, {
    margin: topMargin9
  }, /* @__PURE__ */React81.createElement("div", null, pills.map((pill, index) => /* @__PURE__ */React81.createElement(EGDSBasicPill, {
    key: `egds-basic-pill-${index}`,
    onChange,
    data: pill
  })))));
};
OffersListFilterPills.displayName = "OffersListFilterPills";
OffersListFilterPills.fragment = __Fragment38;

// src/components/offers/__private/__fragments/offers-list/offers-list.tsx
var __Fragment39 = gql90`
  fragment OffersListFragment on ActivityOffersListComponent {
    heading
    offers {
      ...OfferDetailsCardFragment
    }
    offersMessage {
      ...OfferMessageFragment
    }
    dateRange {
      ...EGDSDateRangeFragment
    }
    datePickerLink {
      ...ActivityDateRangePickerDialogFragment
    }
    pointsToggle {
      ...ActivityToggleFragment
    }
    filters {
      ...OffersListFilterPillsFragment
    }
  }

  ${ActivityToggle.fragment}
  ${ActivityDateRangePickerDialog.fragment}
  ${ActivitiesEGDSDateRange.fragment}
  ${OfferDetailsCard.fragment}
  ${OfferMessage.fragment}
  ${OffersListFilterPills.fragment}
`;
var __OffersListLazyQuery = gql90`
  query OffersListLazyQuery(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
    $selectedDate: DateInput
  ) {
    activityInfo(
      context: $context
      activityId: $activityId
      dateRange: $dateRange
      destination: $destination
      detailsViewOptions: $detailsViewOptions
      offerFilters: $offerFilters
    ) {
      offersComponent(selectedDate: $selectedDate) {
        offersListComponent {
          ...OffersListFragment
        }
      }
    }
  }

  ${__Fragment39}
`;
var dateRangeTopMargin = {
  small: {
    blockstart: "six"
  },
  medium: {
    blockstart: "unset"
  }
};
var headingGridColumns = {
  medium: ["1fr", "auto"]
};
var offersListTopMargin = {
  blockstart: "six"
};
var OffersList = ({
  className,
  data,
  sectionRef,
  createTripOnClick,
  setCreateTripLoading,
  isNestedDialog,
  jumplinkTabRefs,
  onSwpToggle,
  oneKeyToggleState
}) => {
  var _a, _b;
  const {
    context
  } = useBexApi2();
  const {
    inputs
  } = useOffersInputsContext();
  const [offersListComponentData, setOffersListComponentData] = React82.useState(data);
  const [dateRangeComponentLoading, setDateRangeComponentLoading] = React82.useState(false);
  const {
    heading,
    offers,
    offersMessage,
    dateRange,
    datePickerLink,
    pointsToggle,
    filters
  } = offersListComponentData;
  const [selectedDateRange, setSelectedDateRange] = React82.useState((_a = inputs.dateRange) != null ? _a : void 0);
  const [selectedDateState, setSelectedDate] = React82.useState((_b = inputs.selectedDate) != null ? _b : findFirstAvailableDate(dateRange.results));
  const [selectedFilterPills, setSelectedFilterPills] = React82.useState([]);
  const [detailsViewOptionsState, setDetailsViewOptionsState] = React82.useState(inputs.detailsViewOptions ? [...(inputs.detailsViewOptions || [])] : null);
  const variables = React82.useMemo(() => __spreadProps(__spreadValues({}, inputs), {
    context,
    detailsViewOptions: detailsViewOptionsState,
    dateRange: selectedDateRange,
    offerFilters: selectedFilterPills.length ? {
      selections: selectedFilterPills
    } : null,
    selectedDate: selectedDateState
  }), [context, inputs, detailsViewOptionsState, selectedDateRange, selectedFilterPills, selectedDateState]);
  const isMounted = useRef2(false);
  const [offersListLazyQuery, options] = useLazyQuery2(__OffersListLazyQuery, {
    onCompleted: results => {
      var _a2;
      const offersListComponent = (_a2 = results.activityInfo.offersComponent) == null ? void 0 : _a2.offersListComponent;
      if (offersListComponent) {
        setOffersListComponentData(offersListComponent);
      }
      setDateRangeComponentLoading(false);
    },
    fetchPolicy: "no-cache",
    ssr: false
  });
  React82.useEffect(() => {
    if (isMounted.current && oneKeyToggleState !== void 0) {
      handlePointsToggleOnChange(oneKeyToggleState);
    } else {
      isMounted.current = true;
    }
  }, [oneKeyToggleState]);
  const handleDateRangeOnClick = React82.useCallback(date => {
    const newDate = convertDateFragmentToInput(date);
    setSelectedDate(newDate);
    variables.selectedDate = newDate;
    offersListLazyQuery({
      variables
    });
  }, [variables, offersListLazyQuery]);
  const handleDateRangePickerOnSubmit = React82.useCallback((startDate, endDate) => {
    setDateRangeComponentLoading(true);
    const newDateRange = convertDateRangeStringToInput(startDate, endDate);
    const newDate = convertDateStringToInput(startDate);
    setSelectedDateRange(newDateRange);
    setSelectedDate(newDate);
    variables.dateRange = newDateRange;
    variables.selectedDate = newDate;
    offersListLazyQuery({
      variables
    });
  }, [variables, offersListLazyQuery]);
  const handleFilterOnChange = React82.useCallback(evt => {
    const {
      name,
      value,
      checked
    } = evt.currentTarget;
    const selection = {
      id: name,
      value
    };
    let newSelectedFilters;
    if (!checked) {
      newSelectedFilters = selectedFilterPills.filter(selectedFilter => selectedFilter.value !== value);
      setSelectedFilterPills(newSelectedFilters);
    } else {
      newSelectedFilters = [...selectedFilterPills];
      newSelectedFilters.push(selection);
      setSelectedFilterPills(newSelectedFilters);
    }
    variables.offerFilters = {
      selections: newSelectedFilters
    };
    offersListLazyQuery({
      variables
    });
  }, [variables, selectedFilterPills, offersListLazyQuery]);
  const handlePointsToggleOnChange = React82.useCallback(checked => {
    onSwpToggle == null ? void 0 : onSwpToggle(checked);
    if (!checked) {
      setDetailsViewOptionsState(null);
      variables.detailsViewOptions = null;
    } else {
      setDetailsViewOptionsState(["SHOP_WITH_POINTS" /* SHOP_WITH_POINTS */]);
      variables.detailsViewOptions = ["SHOP_WITH_POINTS" /* SHOP_WITH_POINTS */];
    }
    offersListLazyQuery({
      variables
    });
  }, [variables, offersListLazyQuery, onSwpToggle]);
  const jumpLinkTabRef = jumplinkTabRefs && sectionRef ? jumplinkTabRefs[sectionRef] : void 0;
  return /* @__PURE__ */React82.createElement("div", {
    className,
    id: sectionRef,
    ref: jumpLinkTabRef
  }, /* @__PURE__ */React82.createElement(Viewport3, null, /* @__PURE__ */React82.createElement(ViewSmall3, null, /* @__PURE__ */React82.createElement(OneKeyBanner, {
    inputs: {
      useLoyaltyCurrency: oneKeyToggleState || null,
      pageLocation: PageLocation.DETAILS,
      packageLOB: null,
      packageType: null,
      lineOfBusiness: LineOfBusinessDomain.ACTIVITIES,
      searchContext: null
    },
    switchHandler: handlePointsToggleOnChange,
    productType: ProductType.Activities,
    spacing: {
      margin: {
        small: {
          blockend: "two"
        }
      }
    }
  })), /* @__PURE__ */React82.createElement(ViewMedium3, null)), /* @__PURE__ */React82.createElement(EGDSLayoutGrid7, {
    space: "three",
    alignItems: "center",
    columns: headingGridColumns
  }, /* @__PURE__ */React82.createElement(EGDSLayoutGridItem7, null, heading && /* @__PURE__ */React82.createElement(EGDSHeading10, {
    size: 4,
    tag: "h4",
    tabIndex: -1
  }, heading)), /* @__PURE__ */React82.createElement(EGDSLayoutGridItem7, null, /* @__PURE__ */React82.createElement(ActivityDateRangePickerDialog, {
    onSubmitHandler: handleDateRangePickerOnSubmit,
    data: datePickerLink,
    isNestedDialog
  }))), /* @__PURE__ */React82.createElement(Viewport3, null, /* @__PURE__ */React82.createElement(ViewSmall3, null), /* @__PURE__ */React82.createElement(ViewMedium3, null, /* @__PURE__ */React82.createElement(EGDSSpacingHr4, null))), /* @__PURE__ */React82.createElement(EGDSSpacing24, {
    margin: dateRangeTopMargin
  }, /* @__PURE__ */React82.createElement(ActivitiesEGDSDateRange, {
    loading: dateRangeComponentLoading,
    onClick: handleDateRangeOnClick,
    data: dateRange,
    selectedDate: selectedDateState && convertDateInputToFragment(selectedDateState)
  })), pointsToggle && /* @__PURE__ */React82.createElement(EGDSSpacing24, {
    margin: offersListTopMargin
  }, /* @__PURE__ */React82.createElement(ActivityToggle, {
    onChange: handlePointsToggleOnChange,
    data: pointsToggle
  })), filters && /* @__PURE__ */React82.createElement(EGDSSpacing24, {
    margin: offersListTopMargin
  }, /* @__PURE__ */React82.createElement(OffersListFilterPills, {
    onChange: handleFilterOnChange,
    data: filters
  })), offersMessage && /* @__PURE__ */React82.createElement(OfferMessage, {
    data: offersMessage
  }), offers == null ? void 0 : offers.map((offer, index) => /* @__PURE__ */React82.createElement(EGDSSpacing24, {
    key: `offers-list-key-${index}`,
    margin: offersListTopMargin
  }, /* @__PURE__ */React82.createElement(OfferDetailsCard, {
    loading: options.loading,
    data: offer,
    key: `offer-details-card-${index}`,
    detailsViewOptions: detailsViewOptionsState,
    selectedDate: selectedDateState,
    selectedDateRange,
    createTripOnClick,
    setCreateTripLoading,
    isNestedDialog
  }))));
};
OffersList.displayName = "OffersList";
OffersList.fragment = __Fragment39;

// src/components/offers/__private/__fragments/offers-summary/offers-list-dialog/offers-list-dialog.tsx
var __Fragment40 = gql91`
  fragment OffersListDialogFragment on ActivityOffersListDialog {
    offersList {
      ...OffersListFragment
    }
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${ActivityDialogTrigger.fragment}
  ${EGDSDialogToolbar.fragment}
  ${OffersList.fragment}
`;
var OffersListDialog = ({
  className,
  data,
  createTripOnClick,
  setCreateTripLoading,
  oneKeyToggleState,
  onSwpToggle
}) => {
  var _a;
  const {
    offersList,
    dialog,
    trigger
  } = data;
  const clickTracker = useClickTracker22();
  const dialogKey = useIdCompatibility10();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog10(`offers-list-dialog-${dialogKey}`);
  const triggerRef = React83.useRef(null);
  const {
    inputs,
    dispatch
  } = useOffersInputsContext();
  const {
    activitySignIn
  } = ((_a = offersList == null ? void 0 : offersList.offers) == null ? void 0 : _a[0]) || {};
  const activitySignInDialog = activitySignIn == null ? void 0 : activitySignIn.activityMemberSignIn;
  const signInExperiment = useExperiment2("SignIn_Popup_for_Guest_Users");
  const partnerOnboardingExperiment = useExperiment2("Opensite_Partner_Onboarding");
  const shouldDisplaySignInDialog = signInExperiment.exposure.bucket > 0 || partnerOnboardingExperiment.exposure.bucket > 0;
  const [, dialogActionForSignInDialog] = useDialog10("activity-signin-dialog");
  const handleToolbarAction = React83.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dispatch(__spreadProps(__spreadValues({}, inputs), {
      detailsViewOptions: oneKeyToggleState ? ["SHOP_WITH_POINTS" /* SHOP_WITH_POINTS */] : null
    }));
    dialogActions.closeDialog();
  }, [dialogActions, dialog.closeAnalytics, clickTracker]);
  const handleSignInPopUpOnClick = React83.useCallback(async () => {
    dialogActionForSignInDialog.openDialog();
  }, []);
  const renderOfferListDialog = viewportType => /* @__PURE__ */React83.createElement(EGDSSheet6, {
    type: viewportType,
    isVisible: true,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React83.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: handleToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React83.createElement(EGDSDialogContent5, null, /* @__PURE__ */React83.createElement(OffersList, {
    data: offersList,
    createTripOnClick,
    setCreateTripLoading,
    isNestedDialog: true,
    oneKeyToggleState,
    onSwpToggle
  })));
  return /* @__PURE__ */React83.createElement("div", {
    className
  }, shouldDisplaySignInDialog && activitySignInDialog ? /* @__PURE__ */React83.createElement(React83.Fragment, null, /* @__PURE__ */React83.createElement("div", {
    "data-testid": "check-availability--button"
  }, /* @__PURE__ */React83.createElement(ActivityDialogTrigger, {
    openDialog: handleSignInPopUpOnClick,
    data: trigger,
    domRef: triggerRef
  })), /* @__PURE__ */React83.createElement(Viewport4, null, /* @__PURE__ */React83.createElement(ViewSmall4, null, /* @__PURE__ */React83.createElement(ActivitySignInDialog, {
    data: activitySignInDialog,
    dialogId: "activity-signin-dialog"
  })), /* @__PURE__ */React83.createElement(ViewMedium4, null, /* @__PURE__ */React83.createElement(ActivitySignInDialog, {
    data: activitySignInDialog,
    dialogId: "activity-signin-dialog"
  })))) : /* @__PURE__ */React83.createElement(React83.Fragment, null, /* @__PURE__ */React83.createElement("div", {
    "data-testid": "check-availability--button"
  }, /* @__PURE__ */React83.createElement(ActivityDialogTrigger, {
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  })), /* @__PURE__ */React83.createElement(EGDSSheetTransition10, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React83.createElement(DialogComponent, null, /* @__PURE__ */React83.createElement(Viewport4, null, /* @__PURE__ */React83.createElement(ViewSmall4, null, renderOfferListDialog("full" /* FULL_SCREEN */)), /* @__PURE__ */React83.createElement(ViewMedium4, null, renderOfferListDialog("centered" /* CENTERED */)))))));
};
OffersListDialog.displayName = "OffersListDialog";
OffersListDialog.fragment = __Fragment40;

// src/components/offers/__private/__fragments/offers-summary/offers-summary.tsx
var __Fragment41 = gql92`
  fragment OffersSummaryFragment on ActivityOffersSummaryComponent {
    heading
    priceDisplay {
      ...ActivityPriceDisplayFragment
    }
    dateRange {
      ...EGDSDateRangeFragment
    }
    datePickerLink {
      ...ActivityDateRangePickerDialogFragment
    }
    offersButton {
      ...OffersListDialogFragment
    }
  }

  ${ActivityDateRangePickerDialog.fragment}
  ${ActivityPriceDisplay.fragment}
  ${ActivitiesEGDSDateRange.fragment}
  ${OffersListDialog.fragment}
`;
var topMargin10 = {
  blockstart: "three"
};
var insidePadding = "three";
var priceGridColumns = ["3fr", "2fr"];
var OffersSummary = ({
  className,
  data,
  sectionRef,
  createTripOnClick,
  setCreateTripLoading,
  jumplinkTabRefs,
  oneKeyToggleState,
  onSwpToggle
}) => {
  var _a;
  const {
    inputs,
    dispatch
  } = useOffersInputsContext();
  const {
    heading,
    priceDisplay,
    dateRange,
    datePickerLink,
    offersButton
  } = data;
  const selectedDate = (_a = inputs.selectedDate) != null ? _a : findFirstAvailableDate(dateRange.results);
  const handleDateRangeOnClick = date => {
    dispatch({
      selectedDate: convertDateFragmentToInput(date)
    });
  };
  const handleDateRangePickerOnSubmit = (startDate, endDate) => {
    dispatch({
      dateRange: convertDateRangeStringToInput(startDate, endDate)
    });
  };
  const jumpLinkTabRef = jumplinkTabRefs && sectionRef ? jumplinkTabRefs[sectionRef] : void 0;
  const triggerRef = React84.useRef(null);
  return /* @__PURE__ */React84.createElement("div", {
    className,
    id: sectionRef,
    ref: jumpLinkTabRef
  }, /* @__PURE__ */React84.createElement(EGDSSpacing25, {
    padding: insidePadding
  }, /* @__PURE__ */React84.createElement(EGDSCard4, null, heading && /* @__PURE__ */React84.createElement(EGDSHeading11, {
    size: 4,
    tag: "h4",
    tabIndex: -1
  }, heading), /* @__PURE__ */React84.createElement(EGDSSpacing25, {
    margin: topMargin10
  }, /* @__PURE__ */React84.createElement(ActivityDateRangePickerDialog, {
    onSubmitHandler: handleDateRangePickerOnSubmit,
    data: datePickerLink
  })), /* @__PURE__ */React84.createElement(EGDSSpacingHr5, null), /* @__PURE__ */React84.createElement(ActivitiesEGDSDateRange, {
    onClick: handleDateRangeOnClick,
    data: dateRange,
    selectedDate: selectedDate && convertDateInputToFragment(selectedDate)
  }))), /* @__PURE__ */React84.createElement(EGDSSheetTransition11, {
    isVisible: true
  }, /* @__PURE__ */React84.createElement(EGDSSheet7, {
    isVisible: true,
    type: "bottom",
    triggerRef,
    autoFocus: false
  }, /* @__PURE__ */React84.createElement(EGDSSpacing25, {
    margin: topMargin10,
    padding: insidePadding
  }, /* @__PURE__ */React84.createElement(EGDSCard4, null, /* @__PURE__ */React84.createElement(EGDSLayoutGrid8, {
    columns: priceGridColumns,
    space: "half"
  }, /* @__PURE__ */React84.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React84.createElement(ActivityPriceDisplay, {
    align: EGDSPriceLockupAlign5.LEFT,
    data: priceDisplay
  })), /* @__PURE__ */React84.createElement(EGDSLayoutGridItem8, {
    alignSelf: "center",
    justifySelf: "end"
  }, /* @__PURE__ */React84.createElement(OffersListDialog, {
    data: offersButton,
    createTripOnClick,
    setCreateTripLoading,
    oneKeyToggleState,
    onSwpToggle
  }))))))));
};
OffersSummary.displayName = "OffersSummary";
OffersSummary.fragment = __Fragment41;

// src/components/offers/offers.tsx
var __Query = gql93`
  query OffersQuery(
    $context: ContextInput!
    $activityId: String!
    $dateRange: ActivityDateRangeInput
    $destination: ActivityDestinationInput
    $detailsViewOptions: [ActivityDetailViewOptions!]
    $offerFilters: ActivityOfferFilterInput
    $selectedDate: DateInput
  ) {
    activityInfo(
      context: $context
      activityId: $activityId
      dateRange: $dateRange
      destination: $destination
      detailsViewOptions: $detailsViewOptions
      offerFilters: $offerFilters
    ) {
      offersComponent(selectedDate: $selectedDate) {
        offersListComponent {
          ...OffersListFragment
        }
        offersSummaryComponent {
          ...OffersSummaryFragment
        }
        sectionRef
      }
    }
  }

  ${OffersSummary.fragment}
  ${OffersList.fragment}
`;
var offersSectionPadding = "six";
var Offers = props => {
  var _a, _b, _c;
  const {
    inputs,
    skipSsr,
    className,
    createTripOnClick,
    jumplinkTabRefs,
    onSwpToggle,
    oneKeyToggleState
  } = props;
  const {
    context
  } = useBexApi3();
  const [createTripLoading, setCreateTripLoading] = React85.useState(false);
  const [state, dispatch] = React85.useReducer(inputsReducer, __spreadValues({}, inputs));
  const variables = React85.useMemo(() => __spreadProps(__spreadValues({}, state), {
    context,
    detailsViewOptions: inputs.detailsViewOptions
  }), [context, state]);
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    fetchPolicy: void 0,
    ssr: !skipSsr,
    nextFetchPolicy: "cache-and-network"
  });
  const offersSummaryComponent = (_a = data == null ? void 0 : data.activityInfo.offersComponent) == null ? void 0 : _a.offersSummaryComponent;
  const offersListComponent = (_b = data == null ? void 0 : data.activityInfo.offersComponent) == null ? void 0 : _b.offersListComponent;
  const sectionRef = (_c = data == null ? void 0 : data.activityInfo.offersComponent) == null ? void 0 : _c.sectionRef;
  const providerValues = useMemo3(() => ({
    inputs: state,
    dispatch
  }), [state]);
  if (loading) {
    return /* @__PURE__ */React85.createElement(EGDSCard5, {
      className
    }, /* @__PURE__ */React85.createElement(EGDSCardPlaceholder2, {
      startPhase: "light",
      aspectRatio: "r1-3"
    }));
  }
  if (error || !(offersSummaryComponent && offersListComponent)) {
    return null;
  }
  return /* @__PURE__ */React85.createElement(OffersInputsContext.Provider, {
    value: providerValues
  }, /* @__PURE__ */React85.createElement(Viewport5, null, /* @__PURE__ */React85.createElement(ViewSmall5, null, /* @__PURE__ */React85.createElement(OffersSummary, {
    className,
    data: offersSummaryComponent,
    sectionRef,
    createTripOnClick,
    setCreateTripLoading,
    jumplinkTabRefs,
    oneKeyToggleState,
    onSwpToggle
  })), /* @__PURE__ */React85.createElement(ViewMedium5, null, /* @__PURE__ */React85.createElement(EGDSSpacing26, {
    className,
    padding: offersSectionPadding
  }, /* @__PURE__ */React85.createElement(EGDSCard5, null, /* @__PURE__ */React85.createElement(OffersList, {
    data: offersListComponent,
    sectionRef,
    createTripOnClick,
    setCreateTripLoading,
    onSwpToggle,
    jumplinkTabRefs,
    oneKeyToggleState
  }))))), /* @__PURE__ */React85.createElement(EGDSPageLoader, {
    visible: createTripLoading
  }));
};
Offers.displayName = "sharedui-Offers";
export { Offers };